import React, { useState, useEffect, useRef } from 'react';
import './Documents.css';
import '../App.css';
import Header from "../Header/Header.jsx";
import DocumentPreview from "../DocumentPreview/DocumentPreview.jsx";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import { Button, Jumbotron, ListGroup } from "react-bootstrap";
import { withTranslation } from 'react-i18next';
import { MdClose } from "react-icons/md";
import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
    SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Redirect } from "react-router-dom";
import ThemeService from '../../services/ThemeService';
import Utils from '../../services/Utils';
import AttachmentNavItem from './AttachmentNavItem';
import FilterCertificateMsg from '../FilterCertificateMsg/FilterCertificateMsg.jsx';
import EmptyDocsPanel from '../EmptyDocsPanel/EmptyDocsPanel';
import SearchBar from './SearchBar/SearchBar';
import SigningProcessModal from '../Modals/SigningProcessModal';
import LoadingCircle from '../LoadingCircle';
import documentRenderService from '../../services/documentRender/documentRenderService';
import ProfileService from '../../services/Profile/ProfileService';
import CertificateService from '../../services/Certificate/CertificateService';
import DocumentService from '../../services/Document/DocumentService';
import TagsList from './TagsList/TagsList';
import ToastComponent from '../Toast/Toast';
import { CustomModal } from '../CustomModal/CustomModal';
import {
    generateKeyVaultUri, generateRedTrustUri, generateSoftwareUri, generateNebulaUri, generateSwisscomUri,
    generateUanatacaUri, postPrivSignature, generateKeyVaultSendOTPUri, postManagementSignature, generateNebulaAuthMiddleUri,
    generateNebulaAuthEndUri, generateAutofirmaCertificateUri, generateFirmaRemotaUri, deleteManagementSignature,
    generateFirmaRemotaSessionUri, putManagementSignature, generateAutofirmaUri, generateAutofirmaPreSignatureUri,
    getPrivSignature, putPrivSignature, generateFirmaRemotaOTPUri, generateNebulaAuthUri, generateUanatacaOtpUri, generateValidatedIdOtpUri, generateValidatedIdUri
} from '../../services/signatureMethods/customServiceSignature';
import {
    NEBULA, NEBULA_CERTIFICATE_PIN_KEY, SOFTWARE, SOFTWARE_CERTIFICATE_PIN_KEY, KEYVAULT,
    KEYVAULT_CERTIFICATE_PIN_KEY, REDTRUST, REDTRUST_CERTIFICATE_PIN_KEY, UANATACA, UANATACA_CERTIFICATE_PIN_KEY,
    FIRMAREMOTA, FIRMAREMOTA_CERTIFICATE_PIN_KEY, SWISSCOM, OTP, VALIDATEDID_CERTIFICATE_PIN_KEY, VALIDATEDID, DOCUMENTS_LIST, PREVIEW,
    IVNOSYS
} from '../../services/signatureMethods/constants';
import RedTrustSignature from '../RedTrustSignature/RedTrustSignature.component';
import UanatacaSignature from '../UanatacaSignature/UanatacaSignature.component';
import KeyVaultSignature from '../KeyVaultSignature/KeyVaultSignature.component';
import SoftwareSignature from '../SotwareSignature/SoftwareSignature.component';
import FirmaRemota from '../FirmaRemota/FirmaRemota.component';
import AutofirmaSignature from '../AutofirmaSignature/Autofirma.component';
import SwisscomSignature from '../SwisscomSignature/SwisscomSignature.component';
import NebulaSignature from '../NebulaSignature/NebulaSignature.component';
import { checkShowNoPinConfirmationModal } from '../../services/signatureMethods/helperService';
import ValidatedIdSignature from '../ValidatedIdSignature/ValidatedIdSignature.component';
import attachmentIcon from './../../assets/icons/attachment.png';
import infoIcon from './../../assets/icons/info.png';
import lockIcon from './../../assets/icons/lock.png';
import { useSelector, useDispatch } from 'react-redux';
import DocumentsActionTypes from '../../redux/documents/documents.types';

import warning from '../../assets/icons/warning-jumbotron.png';
import { getPendingDocumentsRequest } from '../../redux/documents/documents.actions';
import documentMapService from '../../services/documentMapService/documentMapService';
import IvnosysSignature from '../IvnosysSignature/IvnosysSignature.component';
import TrustProSyncBanner from '../TrustProSyncBanner/TrustProSyncBanner';
import IconButton from '../IconButton/IconButton';
import { ReactComponent as EyeIcon } from '../../assets/icons/eye-table.svg';
import { ReactComponent as RefreshIcon } from '../../assets/icons/refresh.svg';

const ipLocation = require("iplocation");
const publicIp = require('public-ip');
const { detect } = require('detect-browser');
const browser = detect();

const Documents = (props) => {
    const { t } = props;

    const pendingDocuments = useSelector((state) => state.documents.filteredDocuments);
    const filters = useSelector((state) => state.documents.filters);
    const paginationMeta = useSelector((state) => state.documents.paginationMeta);
    const ordering = useSelector((state) => state.documents.ordering);
    const dispatch = useDispatch();

    // ─── State ───────────────────────────────────────────────────────────────
    const [oauthTokenB64, setOauthTokenB64] = useState(sessionStorage.getItem('oauthTokenB64'));
    const [language] = useState(localStorage.getItem('i18nextLng'));
    const [userToken] = useState(sessionStorage.getItem('userToken'));
    const [urlReturn] = useState(sessionStorage.getItem('urlReturn'));
    // eslint-disable-next-line no-unused-vars
    const [docsSelectedSignerGUIString] = useState(sessionStorage.getItem('docsSelectedSignerGUIString'));
    const [docsSelectedSignerGUI, setDocsSelectedSignerGUI] = useState([]);
    const [viewDocument, setViewDocument] = useState(false);
    const [loading, setLoading] = useState(true);
    const [sessionExpired, setSessionExpired] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [time, setTime] = useState(0);
    const [selectedDoc, setSelectedDoc] = useState({});
    const [renderedDoc, setRenderedDoc] = useState({ pages: {}, totalPages: 0, nextPage: 1 });
    const [rejectedDoc, setRejectedDoc] = useState(false);
    const [signedDoc, setSignedDoc] = useState(false);
    const [redirecting, setRedirecting] = useState(false);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [docsSelected, setDocsSelected] = useState([]);
    const [docCertSelected, setDocCertSelected] = useState(null);
    const [certificatesList, setCertificatesList] = useState([]);
    const [showSignModal, setShowSignModal] = useState(false);
    const [showKeyVaultModal, setShowKeyVaultModal] = useState(false);
    const [showFirmaRemotaModal, setShowFirmaRemotaModal] = useState(false);
    const [showRedTrustModal, setShowRedTrustModal] = useState(false);
    const [showSoftwareModal, setShowSoftwareModal] = useState(false);
    const [showUanatacaModalPin, setShowUanatacaModalPin] = useState(false);
    const [showUanatacaModalOtp, setShowUanatacaModalOtp] = useState(false);
    const [showValidatedIdModalPin, setShowValidatedIdModalPin] = useState(false);
    const [showValidatedIdModalOtp, setShowValidatedIdModalOtp] = useState(false);
    const [showNebulaModal, setShowNebulaModal] = useState(false);
    const [showSwisscomModal, setShowSwisscomModal] = useState(false);
    const [showAutofirmaModal, setShowAutofirmaModal] = useState(false);
    const [showSwisscomConfirmationModal, setShowSwisscomConfirmationModal] = useState(false);
    const [showNoPinConfirmationModal, setShowNoPinConfirmationModal] = useState(false);
    const [certificateSoftwarePin, setCertificateSoftwarePin] = useState('');
    const [certificateKeyVaultPin, setCertificateKeyVaultPin] = useState('');
    const [certificateFirmaRemotaPin, setCertificateFirmaRemotaPin] = useState('');
    const [certificateRedTrustPin, setCertificateRedTrustPin] = useState('');
    const [certificateUanatacaPin, setCertificateUanatacaPin] = useState('');
    const [certificateUanatacaOtp, setCertificateUanatacaOtp] = useState('');
    const [certificateValidatedIdPin, setCertificateValidatedIdPin] = useState('');
    const [certificateValidatedIdOtp, setCertificateValidatedIdOtp] = useState('');
    const [certificateNebulaPin, setCertificateNebulaPin] = useState('');
    const [certificateSelected, setCertificateSelected] = useState({});
    const [loadingSignatureProcess, setLoadingSignatureProcess] = useState(false);
    const [sessionOpened, setSessionOpened] = useState(false);
    const [showError, setShowError] = useState(false);
    const [errorData, setErrorData] = useState('');
    const [errorType, setErrorType] = useState('');
    const [docsSigned, setDocsSigned] = useState(0);
    const [certHidden, setCertHidden] = useState(true);
    const [userIsLoggedByAuthCerts, setUserIsLoggedByAuthCerts] = useState(false);
    const [showJumbotron, setShowJumbotron] = useState(true);
    const [showTrustProSyncBanner, setShowTrustProSyncBanner] = useState(false);
    const [documentInfo, setDocumentInfo] = useState({});
    const [documentSigners, setDocumentSigners] = useState([]);
    const [documentAttatchmentsList, setDocumentAttatchmentsList] = useState([]);
    const [docsAttachedRendered, setDocsAttachedRendered] = useState([]);
    const [swisscomRedirectURL, setSwisscomRedirectURL] = useState("");
    const [swisscomRequestID, setSwisscomRequestID] = useState("");
    const [loadingSwisscomCheck, setLoadingSwisscomCheck] = useState(false);
    const [swisscomError, setSwisscomError] = useState('');
    const [loadingSwisscomRequest, setLoadingSwisscomRequest] = useState(false);
    const [autofirmaPercentage, setAutofirmaPercentage] = useState(0);
    const [clientIp, setClientIp] = useState('');
    const [ipData, setIpData] = useState('');
    const [loadingMorePages, setLoadingMorePages] = useState(false);
    const [previouslyRejectedDoc, setPreviouslyRejectedDoc] = useState(false);
    const [showAdvancedSearch, setShowAdvancedSearch] = useState(true);
    const [nebulaStep1, setNebulaStep1] = useState(false);
    const [nebulaStep2, setNebulaStep2] = useState(false);
    const [nebulaStep3, setNebulaStep3] = useState(false);
    const [showAdditionalSignaturesBatchDisclaimer, setShowAdditionalSignaturesBatchDisclaimer] = useState(false);
    const [showCommonCertificateDisclaimer, setShowCommonCertificateDisclaimer] = useState(false);
    const [showIncompatibleCertificatesModal, setShowIncompatibleCertificatesModal] = useState(false);
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [selectedCertificate, setSelectedCertificate] = useState('');
    const [loadingNebula, setLoadingNebula] = useState(false);
    const [currentDataAutofirma, setCurrentDataAutofirma] = useState({});
    const [showChallengeError, setShowChallengeError] = useState(false);
    const [nebulaPinRequired, setNebulaPinRequired] = useState(true);
    const [isUanatacaQualified, setIsUanatacaQualified] = useState(false);
    const [isValidatedIdQualified, setIsValidatedIdQualified] = useState(false);
    const [preventBatchModal, setPreventBatchModal] = useState(false);
    const [nextDocument, setNextDocument] = useState({});
    const [accessMethod] = useState(sessionStorage.getItem("AccessMethod"));
    const [forceDocumentView, setForceDocumentView] = useState(false);
    const [showIvnosysModal, setShowIvnosysModal] = useState(false);
    // Extra state not declared in original constructor but set via setState
    const [userData, setUserData] = useState(null);
    const [userCertificatesAuth, setUserCertificatesAuth] = useState(null);
    const [userCertsFiltered, setUserCertsFiltered] = useState(null);
    const [NBauthenticator, setNBauthenticator] = useState('');
    const [NBChallenge, setNBChallenge] = useState('');
    const [textAdditionalSignaturesDisclaimer, setTextAdditionalSignaturesDisclaimer] = useState('');
    const [titleAdditionalSignaturesDisclaimer, setTitleAdditionalSignaturesDisclaimer] = useState('');
    const [loadingSignatureProcessAutofirma, setLoadingSignatureProcessAutofirma] = useState(false);
    const [attDocArray, setAttDocArray] = useState([]);
    const [pageToScroll, setPageToScroll] = useState(null); // eslint-disable-line no-unused-vars

    // Trigger states for setState-callback patterns
    const [pendingSignCall, setPendingSignCall] = useState(null);
    const [renderDocTrigger, setRenderDocTrigger] = useState(0);

    // ─── Refs ─────────────────────────────────────────────────────────────────
    const timerRef = useRef(null);
    const authenticatorsRef = useRef([]);
    const isFirstRenderRef = useRef(true);
    const prevFiltersRef = useRef(filters);
    const prevPaginationMetaRef = useRef(paginationMeta);
    const prevOrderingRef = useRef(ordering);

    // ─── Dynamic key helper ───────────────────────────────────────────────────
    const setStateByKey = (key, value) => {
        const setterMap = {
            oauthTokenB64: setOauthTokenB64,
            docsSelectedSignerGUI: setDocsSelectedSignerGUI,
            viewDocument: setViewDocument,
            loading: setLoading,
            sessionExpired: setSessionExpired,
            redirect: setRedirect,
            time: setTime,
            selectedDoc: setSelectedDoc,
            renderedDoc: setRenderedDoc,
            rejectedDoc: setRejectedDoc,
            signedDoc: setSignedDoc,
            redirecting: setRedirecting,
            tokenExpired: setTokenExpired,
            docsSelected: setDocsSelected,
            docCertSelected: setDocCertSelected,
            certificatesList: setCertificatesList,
            showSignModal: setShowSignModal,
            showKeyVaultModal: setShowKeyVaultModal,
            showFirmaRemotaModal: setShowFirmaRemotaModal,
            showRedTrustModal: setShowRedTrustModal,
            showSoftwareModal: setShowSoftwareModal,
            showUanatacaModalPin: setShowUanatacaModalPin,
            showUanatacaModalOtp: setShowUanatacaModalOtp,
            showValidatedIdModalPin: setShowValidatedIdModalPin,
            showValidatedIdModalOtp: setShowValidatedIdModalOtp,
            showNebulaModal: setShowNebulaModal,
            showSwisscomModal: setShowSwisscomModal,
            showAutofirmaModal: setShowAutofirmaModal,
            showSwisscomConfirmationModal: setShowSwisscomConfirmationModal,
            showNoPinConfirmationModal: setShowNoPinConfirmationModal,
            certificateSoftwarePin: setCertificateSoftwarePin,
            certificateKeyVaultPin: setCertificateKeyVaultPin,
            certificateFirmaRemotaPin: setCertificateFirmaRemotaPin,
            certificateRedTrustPin: setCertificateRedTrustPin,
            certificateUanatacaPin: setCertificateUanatacaPin,
            certificateUanatacaOtp: setCertificateUanatacaOtp,
            certificateValidatedIdPin: setCertificateValidatedIdPin,
            certificateValidatedIdOtp: setCertificateValidatedIdOtp,
            certificateNebulaPin: setCertificateNebulaPin,
            certificateSelected: setCertificateSelected,
            loadingSignatureProcess: setLoadingSignatureProcess,
            sessionOpened: setSessionOpened,
            showError: setShowError,
            errorData: setErrorData,
            errorType: setErrorType,
            docsSigned: setDocsSigned,
            certHidden: setCertHidden,
            userIsLoggedByAuthCerts: setUserIsLoggedByAuthCerts,
            showJumbotron: setShowJumbotron,
            showTrustProSyncBanner: setShowTrustProSyncBanner,
            documentInfo: setDocumentInfo,
            documentSigners: setDocumentSigners,
            documentAttatchmentsList: setDocumentAttatchmentsList,
            docsAttachedRendered: setDocsAttachedRendered,
            swisscomRedirectURL: setSwisscomRedirectURL,
            swisscomRequestID: setSwisscomRequestID,
            loadingSwisscomCheck: setLoadingSwisscomCheck,
            swisscomError: setSwisscomError,
            loadingSwisscomRequest: setLoadingSwisscomRequest,
            autofirmaPercentage: setAutofirmaPercentage,
            clientIp: setClientIp,
            ipData: setIpData,
            loadingMorePages: setLoadingMorePages,
            previouslyRejectedDoc: setPreviouslyRejectedDoc,
            showAdvancedSearch: setShowAdvancedSearch,
            nebulaStep1: setNebulaStep1,
            nebulaStep2: setNebulaStep2,
            nebulaStep3: setNebulaStep3,
            showAdditionalSignaturesBatchDisclaimer: setShowAdditionalSignaturesBatchDisclaimer,
            showWarningModal: setShowWarningModal,
            selectedCertificate: setSelectedCertificate,
            loadingNebula: setLoadingNebula,
            currentDataAutofirma: setCurrentDataAutofirma,
            showChallengeError: setShowChallengeError,
            nebulaPinRequired: setNebulaPinRequired,
            isUanatacaQualified: setIsUanatacaQualified,
            isValidatedIdQualified: setIsValidatedIdQualified,
            preventBatchModal: setPreventBatchModal,
            nextDocument: setNextDocument,
            forceDocumentView: setForceDocumentView,
            showIvnosysModal: setShowIvnosysModal,
            userData: setUserData,
            userCertificatesAuth: setUserCertificatesAuth,
            userCertsFiltered: setUserCertsFiltered,
            NBauthenticator: setNBauthenticator,
            NBChallenge: setNBChallenge,
            textAdditionalSignaturesDisclaimer: setTextAdditionalSignaturesDisclaimer,
            titleAdditionalSignaturesDisclaimer: setTitleAdditionalSignaturesDisclaimer,
            loadingSignatureProcessAutofirma: setLoadingSignatureProcessAutofirma,
            attDocArray: setAttDocArray,
            pageToScroll: setPageToScroll,
        };
        const setter = setterMap[key];
        if (setter) setter(value);
    };

    // ─── Methods ──────────────────────────────────────────────────────────────

    const viewDocumentHandler = () => {
        clearVariablesToRenderListProperly();
        setPendingSignaturesSavedInSession();
        setViewDocument(false);
        documentMapService.resetMap();
    };

    const handleReturnToDocumentsList = () => {
        window.history.replaceState(null, '', window.location.pathname);

        dispatch({
            type: DocumentsActionTypes.MODIFY_PAGINATION,
            payload: {
                ...paginationMeta,
                PageNumber: 1,
            },
        });

        setRenderedDoc({
            pages: {},
            totalPages: 0,
            nextPage: 1
        });

        documentMapService.resetMap();

        setPendingSignaturesSavedInSession();

        getPendingDocuments();
    };

    const showRejectedDocHandler = () => {
        unselectDocuments([selectedDoc]);
        handleReturnToDocumentsList();

        setRejectedDoc(true);
        setViewDocument(false);
    };

    const showSignedDocHandler = () => {
        unselectDocuments([selectedDoc]);
        handleReturnToDocumentsList();

        getPendingDocuments();
        setSignedDoc(true);
        setViewDocument(false);
    };

    const doLogOut = () => {
        if (typeof userToken !== "undefined" && userToken === "true" && typeof urlReturn !== "undefined" && urlReturn !== "null" && urlReturn !== "") {
            setRedirecting(true);
            setTimeout(() => {
                window.location.href = atob(urlReturn);
            }, 3000);
        }
        else {
            setRedirect(true);
        }
        sessionStorage.clear();
    };

    const startTimer = () => {
        timerRef.current = setInterval(() => setTime(t => t + 1), 60000);
    };

    // eslint-disable-next-line no-unused-vars
    const stopTimer = () => {
        clearInterval(timerRef.current);
    };

    const handleModalSignatureSuccess = (signatureName, showModalKey, certificatePinKey, certificatePin) => {
        setLoadingSignatureProcess(true);
        setStateByKey(showModalKey, false);
        setStateByKey(certificatePinKey, certificatePin);
        setPendingSignCall(signatureName);
    };

    const handleModalSignatureOtpSuccess = (signatureName, showModalKeyPin, showModalKeyOtp, certificatePinKey, certificatePin, certificateOtp) => {
        if (isUanatacaQualified) {
            setStateByKey(showModalKeyOtp, false);
            setShowUanatacaModalPin(true);
            setCertificateUanatacaOtp(certificateOtp);
            return;
        }

        handleModalSignatureSuccess(signatureName, showModalKeyPin, certificatePinKey, certificatePin);
    };

    const handleModalSignatureValidatedIdSuccess = (signatureName, showModalKeyPin, showModalKeyOtp, certificatePinKey, certificatePin, certificateOtp) => {
        if (isValidatedIdQualified) {
            setStateByKey(showModalKeyOtp, false);
            setShowValidatedIdModalPin(true);
            setCertificateValidatedIdOtp(certificateOtp);
            return;
        }

        handleModalSignatureSuccess(signatureName, showModalKeyPin, certificatePinKey, certificatePin);
    };

    const handleClose = () => {
        setShowSignModal(false);
        setShowKeyVaultModal(false);
        setShowFirmaRemotaModal(false);
        setShowRedTrustModal(false);
        setShowSoftwareModal(false);
        setShowUanatacaModalPin(false);
        setShowUanatacaModalOtp(false);
        setShowValidatedIdModalPin(false);
        setShowValidatedIdModalOtp(false);
        setShowSwisscomModal(false);
        setShowAutofirmaModal(false);
        setShowSwisscomConfirmationModal(false);
        setShowNoPinConfirmationModal(false);
        setLoadingSignatureProcess(false);
        setLoadingSwisscomCheck(false);
        setLoadingSignatureProcessAutofirma(false);
        setCertificateSoftwarePin('');
        setCertificateKeyVaultPin('');
        setCertificateFirmaRemotaPin('');
        setCertificateRedTrustPin('');
        setCertificateUanatacaPin('');
        setCertificateUanatacaOtp('');
        setCertificateValidatedIdPin('');
        setCertificateValidatedIdOtp('');
        setCertificateNebulaPin('');
        setLoadingSwisscomRequest(false);
        setNebulaStep1(false);
        setNebulaStep2(false);
        setNebulaStep3(false);
        setNBauthenticator('');
        setNBChallenge('');
        setShowWarningModal(false);
        setLoadingNebula(false);
        setShowChallengeError(false);
        setTextAdditionalSignaturesDisclaimer('');
        setTitleAdditionalSignaturesDisclaimer('');
        setShowIvnosysModal(false);
    };

    const isSelectAllHidden = () => {
        // eslint-disable-next-line eqeqeq
        if (pendingDocuments == []) return true;

        // Hide the select all checkbox only when nothing in the list is selectable for batch
        // signature (ReadAll docs, or certificate-bearing docs in conflict). Certificate-free docs
        // remain selectable even when the list mixes 2+ distinct certificates (CA-02).
        return pendingDocuments.every(doc => doc.SignerDTO.ReadAll || isCertConflict(doc));
    };

    const handleOnSelect = (row, isSelect, source = DOCUMENTS_LIST) => {
        if (isSelect) {
            return selectDocument(row, source);
        }

        unselectDocuments([row]);
    };

    const handleOnSelectAll = (isSelect, rows) => {
        if (isSelect) {
            rows.forEach((row, i) => selectDocument(row, i === (rows.length - 1)));
            return;
        }

        unselectDocuments(rows);
    };

    const selectDocument = (row, source) => {
        let newDocumentState = {};

        const docHasCertificateVal = docHasCertificate(row.SignerDTO.CentralizedCertificateInfo);

        // docHasCertificate could be null when de doc does not have certificate defined
        if ((docCertSelected !== docHasCertificateVal) && docHasCertificateVal) {
            newDocumentState.docCertSelected = docHasCertificateVal;
        }

        if (docsSelectedSignerGUI.indexOf(row.SignerDTO.SignerGUI) === -1) {
            docsSelectedSignerGUI.push(row.SignerDTO.SignerGUI);
        }
        if (docsSelected.find(doc => doc.SignerDTO.signerGUI === row.SignerDTO.SignerGUI) === undefined) {
            docsSelected.push(row);
        }

        newDocumentState.docsSelectedSignerGUI = docsSelectedSignerGUI;
        newDocumentState.docsSelected = docsSelected;

        sessionStorage.setItem('docsSelectedSignerGUIString', docsSelectedSignerGUI.toString());
        setDocsSelectedSignerGUI([...docsSelectedSignerGUI]);
        setDocsSelected([...docsSelected]);
        if (newDocumentState.docCertSelected !== undefined) {
            setDocCertSelected(newDocumentState.docCertSelected);
        }

        if (docHasCertificateVal && !filters.CertificateGuid && source !== PREVIEW) {
            const { Guid } = row.SignerDTO.CentralizedCertificateInfo;

            dispatch({
                type: DocumentsActionTypes.MODIFY_FILTERS,
                payload: {
                    ...filters,
                    CertificateGuid: Guid,
                }
            });
        }
    };

    const getFilteredPendindSignaturesByCertificate = (pendingSignatures, docHasCertificateVal) => {
        return pendingSignatures.filter((doc => {
            return !filteredTheDifferentCertificate(doc.SignerDTO.CentralizedCertificateInfo, docHasCertificateVal);
        }));
    };

    // eslint-disable-next-line no-unused-vars
    const getCurrentTablePage = (pendingSignatures, signerGuid, currentSizePerPage, isLastDocumentSelected, vdocsSelected) => {
        // Sort table by FileName asc
        const lastAddedDocGuidIndex = pendingSignatures.findIndex(doc => doc.SignerDTO.signerGUI === signerGuid);

        let firstAddedDocGuidIndex;
        // This only runs when I select multiple docs and this is the last one
        if (isLastDocumentSelected) {
            const firstDocSelected = vdocsSelected[0];
            firstAddedDocGuidIndex = pendingSignatures.findIndex(doc => doc.SignerDTO.signerGUI === firstDocSelected.SignerDTO.SignerGUI);
        }

        const docIndexToBeFound = isLastDocumentSelected ? firstAddedDocGuidIndex : lastAddedDocGuidIndex;

        const module = docIndexToBeFound % currentSizePerPage;
        const page = Math.ceil(docIndexToBeFound / currentSizePerPage);

        return module === 0 ? page + 1 : page;
    };

    const docHasCertificate = (CentralizedCertificateInfo) => {
        if (!CentralizedCertificateInfo || !CentralizedCertificateInfo.Guid)
            return null;

        return CentralizedCertificateInfo.Guid;
    };

    const unselectDocuments = (rows) => {
        let vdocsSelected = docsSelected;
        let vdocsSelectedSignerGUI = docsSelectedSignerGUI;

        console.log({ rows });

        const docsSignersGuidsToUnselect = rows.map((doc) => doc.SignerDTO.SignerGUI);

        vdocsSelected = vdocsSelected.filter((vselectedDoc) => {
            return !docsSignersGuidsToUnselect.includes(vselectedDoc.SignerDTO.SignerGUI);
        });

        vdocsSelectedSignerGUI = vdocsSelected.map((doc) => doc.SignerDTO.SignerGUI);

        sessionStorage.setItem('docsSelectedSignerGUIString', vdocsSelectedSignerGUI.toString());
        setDocsSelectedSignerGUI(vdocsSelectedSignerGUI);
        setDocsSelected(vdocsSelected);

        // If no remaining selected document carries an assigned certificate, the batch no longer
        // has a governing certificate, so other certificates become selectable again
        if (!vdocsSelected.some((doc) => docHasCertificate(doc.SignerDTO.CentralizedCertificateInfo))) {
            setDocCertSelected(null);
        }
    };

    const filteredTheDifferentCertificate = (CentralizedCertificateInfo, vdocCertSelected) => {
        var docCertGUID = docHasCertificate(CentralizedCertificateInfo);

        if (!docCertGUID)
            return false;

        if (vdocCertSelected !== docCertGUID)
            return true;
    };

    // Docs without a certificate are never in conflict. A doc with a certificate is in conflict when:
    // - the list mixes 2+ distinct certificates (nothing can be batch-selected until the user
    //   narrows the list, e.g. via the certificate filter in advanced search), or
    // - it differs from the certificate already governing the current batch selection.
    const isCertConflict = (doc) => {
        const docCertGUID = docHasCertificate(doc.SignerDTO.CentralizedCertificateInfo);
        if (!docCertGUID) return false;

        if (hasMultipleCertificatesInList()) return true;

        return !!(docCertSelected && filteredTheDifferentCertificate(doc.SignerDTO.CentralizedCertificateInfo, docCertSelected));
    };

    // Whether the (already filtered) pending list mixes 2 or more different assigned certificates.
    const hasMultipleCertificatesInList = () => {
        const distinctCerts = new Set(
            pendingDocuments
                .map(doc => docHasCertificate(doc.SignerDTO.CentralizedCertificateInfo))
                .filter(Boolean)
        );

        return distinctCerts.size >= 2;
    };

    const loadViDMobileUserCertificateList = () => {
        loadUserData()
            .then(vUserData => {
                if (vUserData) {
                    setUserData(vUserData);
                    loadViDMobileUserCertificateTypes()
                        .then(vUserCertificatesAuth => {
                            vUserCertificatesAuth.Nebula = true;
                            setUserCertificatesAuth(vUserCertificatesAuth);
                            getUserCertificates(vUserData)
                                .then(res => {
                                    if (vUserCertificatesAuth === null) {
                                        var ViDMobileUserAllowSWCerts = true;
                                    } else {
                                        ViDMobileUserAllowSWCerts = vUserCertificatesAuth.Software;
                                        var ViDMobileUserAllowFirmaRemotaCerts = vUserCertificatesAuth.FirmaRemota;
                                        var ViDMobileUserAllowKeyVaultCerts = vUserCertificatesAuth.KeyVault;
                                        var ViDMobileUserAllowRTCerts = vUserCertificatesAuth.RedTrust;
                                        var ViDMobileUserAllowUTCerts = vUserCertificatesAuth.Uanataca;
                                        var ViDMobileUserAllowSwisscomCerts = vUserCertificatesAuth.Swisscom;
                                        var ViDMobileUserAllowAutofirma = vUserCertificatesAuth.Local;
                                        var ViDMobileUserAllowNebulaCerts = vUserCertificatesAuth.Nebula;
                                        var ViDMobileUserAllowValidatedIdCerts = vUserCertificatesAuth.ValidatedID;
                                        var ViDMobileUserAllowedIvnosysCerts = vUserCertificatesAuth.Ivnosys;
                                    }
                                    var userCertsFiltered = res.reduce(function (userCertsAllowed, certificate) {
                                        if ((certificate.CertType === "FirmaRemota" && ViDMobileUserAllowFirmaRemotaCerts) ||
                                            (certificate.CertType === "KeyVault" && ViDMobileUserAllowKeyVaultCerts) ||
                                            (certificate.CertType === "Software" && ViDMobileUserAllowSWCerts) ||
                                            (certificate.CertType === "RedTrust" && ViDMobileUserAllowRTCerts) ||
                                            (certificate.CertType === "Uanataca" && ViDMobileUserAllowUTCerts) ||
                                            (certificate.CertType === "Nebula" && ViDMobileUserAllowNebulaCerts) ||
                                            (certificate.CertType === "ValidatedID" && ViDMobileUserAllowValidatedIdCerts) ||
                                            (certificate.CertType === "Ivnosys" && ViDMobileUserAllowedIvnosysCerts)
                                        ) {
                                            userCertsAllowed.push(certificate);
                                        }
                                        return userCertsAllowed;
                                    }, []);
                                    if (ViDMobileUserAllowSwisscomCerts) {
                                        userCertsFiltered.push({
                                            CertType: "Swisscom",
                                            ExpirationDate: "-",
                                            certalias: "Swisscom"
                                        });
                                    }
                                    if (ViDMobileUserAllowAutofirma) {
                                        userCertsFiltered.push({
                                            CertType: "Autofirma",
                                            ExpirationDate: "-",
                                            certalias: "Autofirma"
                                        });
                                    }
                                    setUserCertsFiltered(userCertsFiltered);
                                    if (ViDMobileUserAllowFirmaRemotaCerts && !res.some(cert => cert.CertType === "FirmaRemota")) {
                                        setShowTrustProSyncBanner(true);
                                    }
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                } else {
                    console.log('no user data');
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    // Re-checks docsSelected right before signing: if two or more of them carry different assigned
    // certificates, the batch must not be signed (fully nor partially), regardless of how it got selected.
    const hasIncompatibleCertificates = () => {
        let governingCert = null;
        return docsSelected.some((doc) => {
            const cert = docHasCertificate(doc.SignerDTO.CentralizedCertificateInfo);
            if (!cert) return false;
            if (governingCert === null) {
                governingCert = cert;
                return false;
            }
            return governingCert !== cert;
        });
    };

    const filterCertsByDocCert = () => {
        if (hasIncompatibleCertificates()) {
            setShowIncompatibleCertificatesModal(true);
            return;
        }

        var vuserCertsFiltered = userCertsFiltered;
        if (docCertSelected !== null && userCertsFiltered) {
            vuserCertsFiltered = userCertsFiltered.reduce(function (userCertsAllowed, certificate) {
                if ((certificate.GUID === docCertSelected)) {
                    userCertsAllowed.push(certificate);
                }
                return userCertsAllowed;
            }, []);
        }
        if (typeof vuserCertsFiltered !== 'undefined' && vuserCertsFiltered.length > 0) {
            if (vuserCertsFiltered.length === 1) {
                handleCertSelection(vuserCertsFiltered[0], []);
                return;
            }
            var vCertificatesList = vuserCertsFiltered.map((certificate, index) => {
                const isSignatureWithVC = certificate.CertType === "KeyVault" && certificate.IsWalletLinked;

                return (
                    <ListGroup.Item
                        key={certificate.GUID + certificate.certalias + index}
                        action
                        variant="light"
                        onClick={() => handleCertSelection(certificate, docsSelectedSignerGUI)}
                    >
                        <ul className="list-container">
                            {
                                ((docsSelectedSignerGUI.length > 1 && (certificate.CertType === "Ivnosys" || certificate.certalias === "Swisscom")) || (docsSelectedSignerGUI.length >= 1 && isSignatureWithVC)) &&
                                <li>{certificate.certalias + t('documents.certificate-unavailable')}</li>
                            }
                            {
                                (docsSelectedSignerGUI.length === 1 && (certificate.certalias === "Swisscom")) &&
                                <li>{certificate.certalias}</li>
                            }
                            {
                                ((docsSelectedSignerGUI.length > 1 && !isSignatureWithVC && (certificate.CertType !== "Ivnosys" && certificate.certalias !== "Swisscom")) || (docsSelectedSignerGUI.length === 1 && (certificate.certalias !== "Swisscom") && !isSignatureWithVC)) &&
                                <>
                                    <li>{t('general.alias')}: {(certificate.AuthenticationType === 'OTP' || (certificate.DN && certificate.CertType.toLowerCase() === VALIDATEDID)) && certificate.DN} {certificate.AuthenticationType !== 'OTP' && certificate.certalias}</li>
                                    <li>{t('general.type')}: {certificate.CertType === "FirmaRemota" && "TrustPRO"} {certificate.certalias !== "Swisscom" && certificate.CertType} </li>
                                    <li>{t('general.expiration-date')}: {certificate.ExpirationDate}</li>
                                </>
                            }
                        </ul>
                    </ListGroup.Item>
                );
            });
            setCertificatesList(vCertificatesList);
            setShowSignModal(true);
            return;
        }

        // Show Autofirma cert by default
        if (userCertificatesAuth.Local) {
            const certificate = {
                CertType: "Autofirma"
            };
            const vCertificatesListAutofirma = <>
                <ListGroup.Item
                    key={"Autofirma"}
                    action
                    variant="light"
                    onClick={() => handleCertSelection(certificate)}
                >
                    <ul className="list-container">
                        <li>{t('general.alias')}: Autofirma</li>
                        <li>{t('general.type')}: Autofirma </li>
                        <li>{t('general.expiration-date')}: --</li>
                    </ul>
                </ListGroup.Item>
            </>;
            setCertificatesList(vCertificatesListAutofirma);
            setShowSignModal(true);
            return;
        }

        setCertificatesList(<p>{t('documents.cert-type-selection-empty')}</p>);
        setShowSignModal(true);
    };

    const handleCertSelection = (certificate, vdocsSelected) => {
        var showKeyVaultModal = false;
        var showFirmaRemotaModal = false;
        var showSoftwareModal = false;
        var showRedTrustModal = false;
        var showNebulaModal = false;
        var showSwisscomModal = false;
        var showAutofirmaModal = false;
        var showNoPinConfirmationModal = false;
        var showWarningModal = false;
        let vPreventBatchModal = false;
        let showIvnosysModal = false;
        if (checkShowNoPinConfirmationModal(certificate)) {
            showNoPinConfirmationModal = true;
            setNebulaPinRequired(false);
        }
        else {
            if (certificate.CertType === "KeyVault" && certificate.IsWalletLinked) {
                vPreventBatchModal = true;
            } else if (certificate.CertType === "KeyVault" && certificate.AuthenticationType === "PIN" && !certificate.IsWalletLinked) {
                showKeyVaultModal = true;
            } else if (certificate.CertType === "KeyVault" && certificate.AuthenticationType === "SMS" && !certificate.IsWalletLinked) {
                showKeyVaultModal = true;
                keyVaultSendOTP(certificate);
            }
            if (certificate.CertType === "FirmaRemota" && certificate.AuthenticationType === "APP") {
                showFirmaRemotaModal = true;
            }
            if (certificate.CertType === "FirmaRemota" && certificate.AuthenticationType === "SMS") {
                showFirmaRemotaModal = true;
                firmaRemotaSendOTP();
            }
            if (certificate.CertType === "Software") {
                showSoftwareModal = true;
            }
            if (certificate.CertType === "RedTrust") {
                showRedTrustModal = true;
            }
            if (certificate.CertType === "Uanataca") {
                isQualifiedCertificate(certificate.AuthenticationType);
            }
            if (certificate.CertType === "ValidatedID") {
                isValidatedIdCertificateQualified(certificate.AuthenticationType);
            }
            if (certificate.CertType === "Swisscom" && vdocsSelected.length === 1) {
                showSwisscomModal = true;
            }
            if (certificate.CertType === "Autofirma") {
                if (vdocsSelected.length > 1) {
                    vPreventBatchModal = true;
                } else {
                    showAutofirmaModal = true;
                    signDocAutofirma();
                }

            }
            if (certificate.CertType === "Nebula") {
                getAuthenticators();
                showNebulaModal = true;
            }
            if (certificate.CertType === "Swisscom" && vdocsSelected.length > 1) {
                vPreventBatchModal = true;
                //   showWarningModal = true;
            }
            if (certificate.CertType === "Ivnosys") {
                if (vdocsSelected.length > 1) {
                    vPreventBatchModal = true;
                } else {
                    showIvnosysModal = true;
                }
            }
        }
        setShowKeyVaultModal(showKeyVaultModal);
        setShowFirmaRemotaModal(showFirmaRemotaModal);
        setShowSoftwareModal(showSoftwareModal);
        setShowRedTrustModal(showRedTrustModal);
        setShowSwisscomModal(showSwisscomModal);
        setShowAutofirmaModal(showAutofirmaModal);
        setShowNebulaModal(showNebulaModal);
        setShowNoPinConfirmationModal(showNoPinConfirmationModal);
        setShowSignModal(false);
        setCertificateSelected(certificate);
        setShowWarningModal(showWarningModal);
        setSelectedCertificate(certificate.CertType);
        setPreventBatchModal(vPreventBatchModal);
        setShowIvnosysModal(showIvnosysModal);
    };

    const isQualifiedCertificate = (authenticationType) => {
        if (authenticationType === OTP) {
            setIsUanatacaQualified(true);
            var viDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();

            const body = {
                Uses: docsSelected.length
            };

            postManagementSignature(generateUanatacaOtpUri(viDMobileUserGUID), body, oauthTokenB64)
                .then(res => {
                    setShowUanatacaModalOtp(true);
                })
                .catch(function (error) {
                    handleSignatureError(error, UANATACA_CERTIFICATE_PIN_KEY);
                });

            return;
        }

        setShowUanatacaModalPin(true);
    };

    const isValidatedIdCertificateQualified = (authenticationType) => {
        if (authenticationType === OTP) {
            setIsValidatedIdQualified(true);
            var viDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();

            const body = {
                Uses: docsSelected.length
            };

            postManagementSignature(generateValidatedIdOtpUri(viDMobileUserGUID), body, oauthTokenB64)
                .then(res => {
                    setShowValidatedIdModalOtp(true);
                })
                .catch(function (error) {
                    handleSignatureError(error, VALIDATEDID_CERTIFICATE_PIN_KEY);
                });

            return;
        }

        setShowValidatedIdModalPin(true);
    };

    const getAuthenticators = () => {
        setLoadingNebula(true);
        var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();

        const dataJson = {
            IsSign: true
        };

        // Reset Nebula PIN when requesting authenticators
        setCertificateNebulaPin('');

        postManagementSignature(generateNebulaAuthUri(ViDMobileUserGUID), dataJson, oauthTokenB64)
            .then(res => {
                setLoadingNebula(false);
                authenticatorsRef.current = res.data.Authenticators;

                if (authenticatorsRef.current.length === 1) {
                    setNebulaStep1(false);
                    setNebulaStep2(true);
                    setNBauthenticator(authenticatorsRef.current[0]);
                    // Pass value directly: setNBauthenticator is async, state would be stale here
                    sendAuthenticator(authenticatorsRef.current[0]);
                } else {
                    setNebulaStep1(true);
                }
            })
            .catch(function (error) {
                setLoadingNebula(false);
                handleGenericError(error);
            });
    };

    const handleAuthenticatorChange = (e) => {
        setNBauthenticator(e.target.value);
    };

    const sendAuthenticator = (authenticatorOverride) => {
        var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();
        const authenticator = authenticatorOverride !== undefined ? authenticatorOverride : NBauthenticator;

        const dataJson = {
            Authenticator: authenticator,
        };

        postManagementSignature(generateNebulaAuthMiddleUri(ViDMobileUserGUID), dataJson, oauthTokenB64)
            .then(res => {
                setNebulaStep1(false);
                setNebulaStep2(true);
            })
            .catch(function (error) {
                handleGenericError(error);
            });
    };

    const sendChallenge = () => {
        setLoadingNebula(true);
        setNebulaStep2(false);
        var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();

        const dataJson = {
            Challenge: NBChallenge,
        };

        postManagementSignature(generateNebulaAuthEndUri(ViDMobileUserGUID), dataJson, oauthTokenB64)
            .then(res => {
                if (!nebulaPinRequired) {
                    signDocSelection('nebula');
                }
                setNebulaStep1(false);
                setNebulaStep2(false);
                setNebulaStep3(true);
                setNBChallenge('');
                setLoadingNebula(false);
            })
            .catch(function (error) {
                if (error.response.data.includes("integrationUnauthorized")) {
                    setShowChallengeError(true);
                    setLoadingNebula(false);
                } else {
                    /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
                    setSessionExpired(true);
                    setLoadingNebula(false);
                    setNBChallenge('');
                    startTimer();
                }
            });
    };

    const signDocNebula = () => {
        setLoadingSignatureProcess(true);
        setShowNebulaModal(false);
        setShowNoPinConfirmationModal(false);

        const dataJson = {
            CertGUID: certificateSelected.GUID,
            PIN: certificateNebulaPin,
            CertType: certificateSelected.CertType,
            AccessMethod: accessMethod
        };

        postPrivSignature(generateNebulaUri(docsSelected[docsSigned].SignerDTO.SignerGUI), dataJson, oauthTokenB64)
            .then(res => {
                handleSignatureSuccess(res.status, NEBULA);
            })
            .catch(function (error) {
                handleSignatureError(error, NEBULA_CERTIFICATE_PIN_KEY);
            });
    };

    // eslint-disable-next-line no-unused-vars
    const signDocIvnosys = () => {
        handleSignatureSuccess(204, IVNOSYS);
    };

    const focusInput = (input) => {
        /**The stimeout is necesary to wait until the DOM is loaded */
        if (input) setTimeout(function () { input.focus(); }, 1);
    };

    const loadUserData = () => {
        setLoading(true);

        return ProfileService.getUserData()
            .then(res => {
                return res.data;
            })
            .catch(function (error) {
                handleGenericError(error);
                throw error;
            });
    };

    const getUserCertificates = (vUserData) => {
        return CertificateService.getUserCertificates(vUserData.legalid)
            .then(res => {
                return res.data;
            })
            .catch(function (error) {
                if (error.response) {
                    handleSessionExpiredError(error.response.status);
                    if (error.response.status === 404) {
                        if (!userCertificatesAuth || (!userCertificatesAuth.Swisscom && !userCertificatesAuth.Autofirma)) {
                            setCertificatesList(<p>{t('documents.cert-type-selection-empty')}</p>);
                            return [];
                        }
                        if (userCertificatesAuth.Swisscom || userCertificatesAuth.Autofirma)
                            return [];
                    }

                    setErrorType(error.response.status);
                    setErrorData(error.response.data);
                    setShowError(true);
                }
                throw error;
            });
    };

    const loadViDMobileUserCertificateTypes = () => {
        return CertificateService.getCertificateTypes()
            .then(res => {
                return res.data;
            })
            .catch(function (error) {
                handleGenericError(error);
                throw error;
            });
    };

    const handleSessionExpiredError = (status) => {
        if (status === 401) {
            /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
            setSessionExpired(true);
            startTimer();
        }
    };

    const handleGenericError = (error) => {
        handleSessionExpiredError(error.response.status);

        if (error.response.status !== 401) {
            setErrorType(error.response.status);
            setErrorData(error.response.data);
            setShowError(true);
        }
    };

    const getViDMobileUserGUIDFromOauthToken = () => {
        var tokenParts = oauthTokenB64.split(".");
        var jsonTokenInfo = atob(tokenParts[1]);
        var tokenInfo = JSON.parse(jsonTokenInfo);
        return tokenInfo.sub;
    };

    const firmaRemotaSendOTP = () => {
        var ViDMobileUserGUID = getViDMobileUserGUIDFromOauthToken();

        putPrivSignature(generateFirmaRemotaOTPUri(ViDMobileUserGUID), "", oauthTokenB64)
            .then(res => {
                //firmaRemota SMS OTP sent
            })
            .catch(function (error) {
                handleGenericError(error);
            });
    };

    const keyVaultSendOTP = (certificate) => {
        const dataJson = {
            AccessMethod: accessMethod
        };

        postPrivSignature(generateKeyVaultSendOTPUri(certificate.GUID), dataJson, oauthTokenB64)
            .then(res => {
                //keyVault SMS OTP sent
            })
            .catch(function (error) {
                handleGenericError(error);
            });
    };

    const signDocSelection = (type) => {
        if (docsSigned !== docsSelected.length && docsSelected[docsSigned]) {
            if (type === SOFTWARE) {
                signDocSoftware();
            }
            if (type === KEYVAULT) {
                signDocKeyVault();
            }
            if (type === REDTRUST) {
                signDocRedTrust();
            }
            if (type === FIRMAREMOTA) {
                signDocFirmaRemota();
            }
            if (type === UANATACA) {
                signDocUanataca();
            }
            if (type === SWISSCOM) {
                signDocSwisscom();
            }
            if (type === NEBULA) {
                signDocNebula();
            }
            if (type === VALIDATEDID) {
                signDocValidatedId();
            }

            if (type === IVNOSYS) {
                handleSignatureSuccess(204, IVNOSYS);
            }

            return;
        }

        if (sessionOpened) {
            firmaRemotaCloseSession();
        }

        sessionStorage.removeItem('docsSelectedSignerGUIString');

        dispatch({
            type: DocumentsActionTypes.MODIFY_PAGINATION,
            payload: {
                ...paginationMeta,
                PageNumber: 1,
                Count: paginationMeta.Count - (docsSigned + 1)
            },
        });

        setDocsSelected([]);
        setDocsSelectedSignerGUI([]);
        setLoadingSignatureProcess(false);
        setDocsSigned(0);
        setCertificateSoftwarePin('');
        setCertificateKeyVaultPin('');
        setCertificateFirmaRemotaPin('');
        setCertificateRedTrustPin('');
        setCertificateUanatacaPin('');
        setCertificateUanatacaOtp('');
        setCertificateValidatedIdPin('');
        setCertificateValidatedIdOtp('');
        setCertificateNebulaPin('');
        getPendingDocuments();
        setSignedDoc(true);
        setShowIvnosysModal(false);
    };

    const signDocSoftware = () => {
        const dataJson = {
            PinAuthentication: certificateSoftwarePin,
            AccessMethod: accessMethod
        };

        postPrivSignature(generateSoftwareUri(docsSelected[docsSigned].SignerDTO.SignerGUI), dataJson, oauthTokenB64)
            .then(res => {
                handleSignatureSuccess(res.status, SOFTWARE);
            })
            .catch(function (error) {
                handleSignatureError(error, SOFTWARE_CERTIFICATE_PIN_KEY);
            });
    };

    const signDocKeyVault = () => {
        const dataJson = {
            CertGUID: certificateSelected.GUID,
            PIN: certificateKeyVaultPin,
            CertType: certificateSelected.CertType,
            AccessMethod: accessMethod
        };

        postPrivSignature(generateKeyVaultUri(docsSelected[docsSigned].SignerDTO.SignerGUI), dataJson, oauthTokenB64)
            .then(res => {
                handleSignatureSuccess(res.status, KEYVAULT);
            })
            .catch(function (error) {
                handleSignatureError(error, KEYVAULT_CERTIFICATE_PIN_KEY);
            });
    };

    const signDocFirmaRemota = () => {
        if (certificateFirmaRemotaPin !== "" && docsSigned === 0) {
            firmaRemotaOpenSession();
        }

        const dataJson = {
            CertGUID: certificateSelected.GUID,
            PIN: certificateFirmaRemotaPin,
            CertType: certificateSelected.CertType,
            AccessMethod: accessMethod
        };

        postPrivSignature(generateFirmaRemotaUri(docsSelected[docsSigned].SignerDTO.SignerGUI), dataJson, oauthTokenB64)
            .then(res => {
                handleSignatureSuccess(res.status, FIRMAREMOTA);
            })
            .catch(function (error) {
                handleSignatureError(error, FIRMAREMOTA_CERTIFICATE_PIN_KEY);
            });
    };

    const handleNoPinDocSignature = () => {
        setLoadingSignatureProcess(true);
        setShowNoPinConfirmationModal(false);
        if (certificateSelected.CertType === "KeyVault") {
            signDocSelection('keyvault');
        }
        if (certificateSelected.CertType === "FirmaRemota") {
            signDocSelection('firmaremota');
        }
        if (certificateSelected.CertType === "Software") {
            signDocSelection('software');
        }
        if (certificateSelected.CertType === "RedTrust") {
            signDocSelection('redtrust');
        }
        if (certificateSelected.CertType === "Uanataca") {
            signDocSelection('uanataca');
        }
        if (certificateSelected.CertType === "ValidatedID") {
            signDocSelection('validatedid');
        }
        if (certificateSelected.CertType === "Nebula") {
            setLoadingSignatureProcess(false);
            setShowNebulaModal(true);
            getAuthenticators();
        }
    };

    const firmaRemotaOpenSession = () => {
        const dataJson = {
            OTP: certificateFirmaRemotaPin
        };

        putManagementSignature(generateFirmaRemotaSessionUri(), dataJson, oauthTokenB64)
            .then(() => {
                setSessionOpened(true);
            })
            .catch(function (error) {
                handleGenericError(error);
            });
    };

    const firmaRemotaCloseSession = () => {
        const dataJson = {
            OTP: certificateFirmaRemotaPin
        };

        deleteManagementSignature(generateFirmaRemotaSessionUri(), dataJson, oauthTokenB64)
            .catch(function (error) {
                handleGenericError(error);
            })
            .finally(() => {
                setCertificateFirmaRemotaPin('');
            });
    };

    const signDocRedTrust = () => {
        const dataJson = {
            CertGUID: certificateSelected.GUID,
            PIN: certificateRedTrustPin,
            CertType: certificateSelected.CertType,
            AccessMethod: accessMethod
        };

        postPrivSignature(generateRedTrustUri(docsSelected[docsSigned].SignerDTO.SignerGUI), dataJson, oauthTokenB64)
            .then(res => {
                handleSignatureSuccess(res.status, REDTRUST);
            })
            .catch(function (error) {
                handleSignatureError(error, REDTRUST_CERTIFICATE_PIN_KEY);
            });
    };

    const handleSignatureSuccess = (status, signatureName) => {
        if (status === 204) {
            const signerGuid = docsSelected[docsSigned].SignerDTO.SignerGUI;
            Utils.removeItemFromSelectedDocsInSessionByGuid(signerGuid);

            setDocsSigned(docsSigned + 1);
            setPendingSignCall(signatureName);
        }
    };

    const handleSignatureError = (error, certificatePinKey) => {
        if (error.response.status === 401) {
            setSessionExpired(true);
            startTimer();
        } else {
            setLoadingSignatureProcess(false);
            setErrorType(error.response.status);
            setErrorData(error.response.data);
            setShowError(true);
            setStateByKey(certificatePinKey, '');
            setDocsSelected([]);
            setDocsSelectedSignerGUI([]);
            setDocsSigned(0);

            getPendingDocuments();
        }
    };

    const signDocUanataca = () => {
        var dataJson = {
            CertGUID: certificateSelected.GUID,
            PIN: certificateUanatacaPin,
            CertType: certificateSelected.CertType,
            AccessMethod: accessMethod
        };

        if (isUanatacaQualified) {
            const dataJsonQF = Object.assign(dataJson, { OTP: certificateUanatacaOtp });
            dataJson = dataJsonQF;
        }

        postPrivSignature(generateUanatacaUri(docsSelected[docsSigned].SignerDTO.SignerGUI), dataJson, oauthTokenB64)
            .then(res => {
                handleSignatureSuccess(res.status, UANATACA);
            })
            .catch(function (error) {
                handleSignatureError(error, UANATACA_CERTIFICATE_PIN_KEY);
            });
    };

    const signDocValidatedId = () => {
        var dataJson = {
            CertGUID: certificateSelected.GUID,
            PIN: certificateValidatedIdPin,
            CertType: certificateSelected.CertType,
            AccessMethod: accessMethod
        };

        if (isValidatedIdQualified) {
            const dataJsonQF = Object.assign(dataJson, { OTP: certificateValidatedIdOtp });
            dataJson = dataJsonQF;
        }

        postPrivSignature(generateValidatedIdUri(docsSelected[docsSigned].SignerDTO.SignerGUI), dataJson, oauthTokenB64)
            .then(res => {
                handleSignatureSuccess(res.status, VALIDATEDID);
            })
            .catch(function (error) {
                handleSignatureError(error, VALIDATEDID_CERTIFICATE_PIN_KEY);
            });
    };

    const signDocSwisscom = () => {
        const dataJson = {
            AccessMethod: accessMethod
        };

        postPrivSignature(generateSwisscomUri(docsSelected[docsSigned].SignerDTO.SignerGUI), dataJson, oauthTokenB64)
            .then(res => {
                var swisscomReturnObj = res.data;
                var isUrlDefined = swisscomReturnObj.RedirectURL ? true : false;
                if (isUrlDefined) {
                    Utils.openTab(swisscomReturnObj.RedirectURL);
                }

                setSwisscomRedirectURL(swisscomReturnObj.RedirectURL);
                setSwisscomRequestID(swisscomReturnObj.RequestID);
                setLoadingSwisscomRequest(false);
            })
            .catch(function (error) {
                handleSessionExpiredError(error.response.status);
                if (error.response.status !== 401) {
                    handleSwisscomErrorMessage(error);
                }
            });
    };

    const completeSwisscomSignature = () => {
        const dataJson = {
            AccessMethod: accessMethod
        };

        postPrivSignature(generateSwisscomUri(docsSelected[docsSigned].SignerDTO.SignerGUI, swisscomRequestID), dataJson, oauthTokenB64)
            .then(res => {
                sessionStorage.removeItem('docsSelectedSignerGUIString');
                setDocsSelected([]);
                setDocsSigned(0);
                setLoadingSwisscomCheck(false);
                setShowSwisscomConfirmationModal(false);
                getPendingDocuments();
                setSignedDoc(true);
            })
            .catch(function (error) {
                if (error.response) {
                    handleSessionExpiredError(error.response.status);
                    if (error.response.status === 409) {
                        setLoadingSwisscomCheck(false);
                        setSwisscomError(t('documents.swisscom-error'));
                    }
                    if (error.response.status !== 401 && error.response.status !== 409) {
                        handleSwisscomErrorMessage(error);
                    }
                }
                else {
                    error.response.status = "Undefined";
                    error.response.data = "Network error";
                    handleSwisscomErrorMessage(error);
                }
            });
    };

    const handleSwisscomErrorMessage = (error) => {
        setErrorType(error.response.status);
        setErrorData(error.response.data);
        setShowError(true);
        setShowSwisscomConfirmationModal(false);
        setShowSwisscomModal(false);
        setLoadingSwisscomCheck(false);
        setLoadingSwisscomRequest(false);
    };

    const signDocAutofirma = () => {
        loadAppAFirma().then(() => {
            doSelectCert();
        });
    };

    const loadAppAFirma = () => {
        return new Promise((resolve, reject) => {
            window.AutoScript.cargarAppAfirma();
            window.AutoScript.setStickySignatory(true);
            setTimeout(() => { resolve(); }, 1500);
        });
    };

    const doSelectCert = () => {
        try {
            window.AutoScript.selectCertificate(
                "",
                showCertCallback,
                showErrorCallback
            );

        } catch (e) {
            console.log("Type: " + window.AutoScript.getErrorType() + "\nMessage: " + window.AutoScript.getErrorMessage());
            setShowAutofirmaModal(false);
        }
    };

    const calculateAutofirmaPercentage = (step) => {
        let index = currentDataAutofirma.index != null ? (currentDataAutofirma.index + 1) : 1;

        // total is 5 steps times document
        const totalSteps = docsSelected.length * 5;

        // calculate completed steps
        const completedDocs = index - 1;
        const completedPreviousDocsSteps = completedDocs * 5;
        const completedSteps = completedPreviousDocsSteps + step;

        // percentage based on steps
        const percentage = (100 * completedSteps / totalSteps);

        return Math.floor(percentage);
    };

    // FUNCION DE FIRMA
    const doSign = (data) => {
        setCurrentDataAutofirma(data);
        setAutofirmaPercentage(calculateAutofirmaPercentage(2));

        const dataJson = {
            CertType: data.certType,
            CertsData: [data.certsData],
            HashAlgorithm: data.hashAlgorithm,
            AccessMethod: accessMethod
        };

        postPrivSignature(generateAutofirmaCertificateUri(data.signerGUI), dataJson, oauthTokenB64)
            .then(res => {
                if (res.status === 204) {
                    getPrivSignature(generateAutofirmaPreSignatureUri(data.signerGUI), oauthTokenB64)
                        .then(response => {
                            setAutofirmaPercentage(calculateAutofirmaPercentage(3));
                            try {
                                /* SE FILTRA POR EL CN SELECCIONADO PREVIAMENTE Y
                                 * SE ACTIVA EL HEADLESS PARA EVITAR QUE VUELVA A SOLICITAR EL CERTIFICADO
                                 * */
                                window.AutoScript.sign(
                                    response.data.PreSignatureContentDNIe,
                                    "SHA512withRSA",
                                    "NONE",
                                    null,
                                    showSignResultCallback,
                                    showErrorCallback);

                            } catch (e) {
                                setLoadingSignatureProcessAutofirma(false);
                                try {
                                    console.log("Type: " + window.AutoScript.getErrorType() + "\nMessage: " + window.AutoScript.getErrorMessage());
                                } catch (ex) {
                                    console.log("Error: " + e);
                                }
                            }
                        })
                        .catch(function (error) {
                            handleAutofirmaSignatureError(error);
                        });
                }
            })
            .catch(function (error) {
                handleAutofirmaSignatureError(error);
            });
    };

    const handleAutofirmaSignatureError = (error) => {
        handleSessionExpiredError(error.response.status);

        setLoadingSignatureProcessAutofirma(false);
        setShowAutofirmaModal(false);
        setErrorType(t('documents.autofirma-title'));
        setErrorData(error.message);
        setShowError(true);
    };

    // FUNCION CALLBACK DE AUTOFIRMA PARA ENVIAR EL RESULTADO DE LA FIRMA
    const showSignResultCallback = (signatureB64) => {
        const evidenceLocation = (ipData.latitude + ipData.longitude).toString;
        const browserStringified = JSON.stringify(browser);
        setAutofirmaPercentage(calculateAutofirmaPercentage(4));

        const dataJson = {
            Signature: signatureB64,
            HashAlgorithm: "SHA512",
            IpAddress: clientIp,
            Location: evidenceLocation,
            From: browserStringified,
            AccessMethod: accessMethod
        };

        postPrivSignature(generateAutofirmaUri(docsSelected[0]?.SignerDTO.SignerGUI), dataJson, oauthTokenB64)
            .then(res => {
                if (currentDataAutofirma.index < docsSelected.length - 1) {
                    currentDataAutofirma.index++;
                    currentDataAutofirma.signerGUI = docsSelected[currentDataAutofirma.index].SignerDTO.SignerGUI;

                    doSign(currentDataAutofirma);
                    return;
                }

                sessionStorage.removeItem('docsSelectedSignerGUIString');
                setAutofirmaPercentage(calculateAutofirmaPercentage(5));
                setDocsSigned(0);
                closeAutofirmaProcess();
            })
            .catch(function (error) {
                handleAutofirmaSignatureError(error);
            });
    };

    const closeAutofirmaProcess = () => {
        setTimeout(() => {
            setDocsSelected([]);
            setLoadingSignatureProcessAutofirma(false);
            setShowAutofirmaModal(false);
            getPendingDocuments();
            setSignedDoc(true);
        }, 1000);
    };

    // FUNCION CALLBACK DE AUTORFIRMA PARA RECOGER EL CERTIFICADO A USAR
    const showCertCallback = (certificateB64) => {
        var pki = window.forge.pki;
        var certPEM = "-----BEGIN CERTIFICATE-----\n" + certificateB64 + "\n-----END CERTIFICATE-----";
        var cert = pki.certificateFromPem(certPEM);
        var CN = cert.subject.getField('CN').value;

        var data = {
            signerGUI: docsSelected[docsSigned].SignerDTO.SignerGUI,
            certType: docsSelected[docsSigned].SignerDTO.TypeOfID,
            certsData: certificateB64,
            hashAlgorithm: "SHA512",
            cn: CN,
            index: 0
        };

        setLoadingSignatureProcessAutofirma(true);
        setAutofirmaPercentage(calculateAutofirmaPercentage(1));

        doSign(data);
    };

    const showErrorCallback = (errorType, errorMessage) => {
        /*if (errorType == "es.gob.afirma.standalone.ApplicationNotFoundException") {
         console.log("Autofirma application is not installed.");
         }
         else {
         console.log("Type: " + errorType + "\nMessage: " + errorMessage);
         }*/
        setShowAutofirmaModal(false);
        setErrorType(t('documents.autofirma-title'));
        setErrorData(<p>{t('documents.autofirma-error')} <a href='https://firmaelectronica.gob.es/Home/Descargas.html' rel="noopener noreferrer" target='_blank'>https://firmaelectronica.gob.es/Home/Descargas.html</a></p>);
        setShowError(true);
    };

    const getClientData = () => {
        (async () => {
            const vClientIp = await publicIp.v4();
            const vIpData = await ipLocation(vClientIp);
            setClientIp(vClientIp);
            setIpData(vIpData);
        })();
    };

    const seeDocument = (e, row) => {
        e.stopPropagation();
        setViewDocument(true);
        setSelectedDoc(row);
        setLoading(true);
        setForceDocumentView(row.SignerDTO.ReadAll);
        setRenderDocTrigger(prev => prev + 1);
    };

    const seeNextDocument = (e) => {
        documentMapService.resetMap();
        setRenderedDoc({
            pages: [],
            totalPages: 0,
            nextPage: 1
        });
        e.stopPropagation();
        setViewDocument(true);
        setSelectedDoc(nextDocument);
        setLoading(true);
        setRenderDocTrigger(prev => prev + 1);
    };

    const handlePreviouslyRejectedDocError = (error, isSigning = false) => {
        if (error.response?.status !== 409) return;
        if (isSigning) {
            setTimeout(() => {
                setViewDocument(false);
                setSelectedDoc({});
                getPendingDocuments();
            }, 3000);
            return;
        }
        setPreviouslyRejectedDoc(true);
        setSelectedDoc({});
    };

    const getPendingDocuments = () => {
        clearVariablesToRenderListProperly();
        var { userToken: vUserToken, urlReturn: vUrlReturn } = { userToken, urlReturn };

        setLoading(true);

        const currentFilters = filters;
        const currentPaginationMeta = paginationMeta;
        const currentOrdering = ordering;

        let paginationMetaToBeUsed = currentPaginationMeta;

        // Check if current Ivnosys process
        const currentIvnosysProcess = localStorage.getItem("currentIvnosysProcess");
        if (currentIvnosysProcess) {
            const ivnosysData = JSON.parse(currentIvnosysProcess);
            const { paginationMeta: paginationMetaFromIvnosys } = ivnosysData;

            paginationMetaToBeUsed = paginationMetaFromIvnosys;
        }

        getPendingDocumentsRequest(currentFilters, paginationMetaToBeUsed, currentOrdering)
            .then(res => {
                if (res) {
                    const pendingSignatures = res.data.List;
                    const { Count, TotalPages, PageNumber } = res.data;

                    dispatch({
                        type: DocumentsActionTypes.MODIFY_PAGINATION,
                        payload: {
                            ...paginationMetaToBeUsed,
                            Count,
                            TotalPages,
                        }
                    });

                    dispatch({
                        type: DocumentsActionTypes.ADD_DOCUMENTS_TO_LIST,
                        payload: pendingSignatures
                    });

                    //aquí debe hacerse el map de pendingsignatures y ver si hay certificados apra mostrar la columna
                    const showCertColumn = pendingSignatures.some(doc => !!doc.SignerDTO.CentralizedCertificateInfo.Guid);

                    setCertHidden(!showCertColumn);

                    if (pendingSignatures.length === 1 && PageNumber === 1) {
                        setViewDocument(true);
                        setSelectedDoc(pendingSignatures[0]);
                        setRenderDocTrigger(prev => prev + 1);
                        return;
                    }

                    setPendingSignaturesSavedInSession();

                    // Check URL params for Ivnosys actions
                    const urlParams = new URLSearchParams(window.location.search);
                    const ivnosysPreSignAuth = urlParams.get('ivnosysPreSignAuth');
                    const ivnosysInitSign = urlParams.get('ivnosysInitSign');
                    if (ivnosysPreSignAuth || ivnosysInitSign) {
                        // recover process data from localStorage
                        const currentIvnosysProcessData = JSON.parse(localStorage.getItem("currentIvnosysProcess"));
                        const { signerGuid } = currentIvnosysProcessData;

                        // find doc by signerGuid
                        const vSelectedDoc = pendingSignatures.find(doc => doc.SignerDTO.SignerGUI === signerGuid);

                        if (vSelectedDoc) {
                            setViewDocument(true);
                            setSelectedDoc(vSelectedDoc);
                            setLoading(true);
                            setForceDocumentView(vSelectedDoc.SignerDTO.ReadAll);
                            setRenderDocTrigger(prev => prev + 1);
                        }
                    }
                }
            })
            .catch(function (error) {
                if (error.response.status === 401) {
                    /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
                    if (typeof vUserToken !== "undefined" && vUserToken === "true" && typeof vUrlReturn !== "undefined" && vUrlReturn !== "null" && vUrlReturn !== "") {
                        setTokenExpired(true);
                        setTimeout(() => {
                            window.location.href = atob(vUrlReturn);
                        }, 3000);
                    }
                    else {
                        setSessionExpired(true);
                        startTimer();
                    }
                }
                // Handle empty documents error
                if (error.response.status === 404) {
                    dispatch({
                        type: DocumentsActionTypes.ADD_DOCUMENTS_TO_LIST,
                        payload: []
                    });
                    setLoading(false);

                    if (typeof vUserToken !== "undefined" && vUserToken === "true" && typeof vUrlReturn !== "undefined" && vUrlReturn !== "null" && vUrlReturn !== "") {
                        setRedirecting(true);
                        setTimeout(() => {
                            window.location.href = atob(vUrlReturn);
                        }, 3000);
                    }
                }

                setLoading(false);
                clearVariablesToRenderListProperly();
            });
    };

    const clearVariablesToRenderListProperly = () => {
        setRenderedDoc({
            pages: [],
            totalPages: 0,
            nextPage: 1
        });
        setSelectedDoc({});
    };

    const setPendingSignaturesSavedInSession = () => {
        const selectedCertificateSession = sessionStorage.getItem("selectedCertificate");
        let docsSelectedGuidString = sessionStorage.getItem('docsSelectedSignerGUIString');
        const enabledDocsIteration = docsSelectedGuidString !== null && docsSelectedGuidString !== "";
        /**Si entra en el if es que hay documentos guardado en sesión en formato string y debe pasarse a
             * array para que la tabla de docs lo reconozca y pueda marcarlos */
        if (enabledDocsIteration) {
            const vdocsSelectedGUI = docsSelectedGuidString.split(",");
            const filteredPendinSignatures = pendingDocuments.filter(doc => vdocsSelectedGUI.includes(doc.SignerDTO.signerGUI));

            filteredPendinSignatures.forEach(doc => {
                selectDocument(doc);
            });
        }
        let newDocumentState = { loading: false };
        if (selectedCertificateSession != null && !enabledDocsIteration) {
            newDocumentState.pendingSignatures = getFilteredPendindSignaturesByCertificate(pendingDocuments, selectedCertificateSession);
            newDocumentState.docCertSelected = selectedCertificateSession;
        }

        setLoading(false);
        if (newDocumentState.docCertSelected !== undefined) {
            setDocCertSelected(newDocumentState.docCertSelected);
        }
    };

    const renderDocument = () => {
        const pages = renderedDoc.pages;
        const nextPage = renderedDoc.nextPage;
        var documentsList = pendingDocuments;

        if (loadingMorePages || nextPage === -1) return;

        let signerGuid = selectedDoc.SignerDTO.SignerGUI;
        let docGuid = selectedDoc.DocGUI;
        const index = documentsList.findIndex((doc) => doc.SignerDTO.SignerGUI === signerGuid);
        if (index < documentsList.length - 1) setNextDocument(documentsList[index + 1]);

        if (pages.length > 0) setLoadingMorePages(true);

        documentRenderService.renderDocumentPages(docGuid, nextPage)
            .then(response => {
                const data = response.data;

                const totalPdfPagesNumber = data.NumberOfPages;
                const nextPageToRender = data.NextPage;
                documentMapService.initializeMap(data.NumberOfPages);
                const newPages = data.DocPageRendered;
                const newPosition = documentMapService.determinePagePosition(nextPage, pages.length - 1);
                const pagesData = documentMapService.updatePagesList(pages, newPages, newPosition);
                documentMapService.updateMap(nextPage, newPages.length, newPosition);

                setLoadingMorePages(false);
                setLoading(false);
                setRenderedDoc({
                    pages: pagesData,
                    nextPage: nextPageToRender,
                    totalPages: totalPdfPagesNumber
                });

            })
            .catch(function (error) {
                handleSessionExpiredError(error?.response?.status);
                setLoadingMorePages(false);
                setLoading(false);
            });

        getDocumentInfoAndAttachments();
    };

    const renderSpecificPage = (selectedPage) => {
        const pages = renderedDoc.pages;
        const docGuid = selectedDoc.DocGUI;
        const pageToRender = parseInt(selectedPage, 10);

        if (loadingMorePages || isNaN(pageToRender)) return;

        const pagePosition = documentMapService.getPagePosition(pageToRender);
        if (pagePosition !== null && pagePosition !== -1) {
            documentMapService.setScroll('pdf-container', pageToRender, pages.length);
            return;
        }

        setLoadingMorePages(true);
        documentRenderService.renderDocumentPages(docGuid, pageToRender)
            .then((response) => {
                const data = response.data;

                const totalPdfPagesNumber = data.NumberOfPages;
                const nextPageToRender = data.NextPage;
                documentMapService.initializeMap(data.NumberOfPages);
                const newPages = data.DocPageRendered;
                const newPosition = documentMapService.determinePagePosition(pageToRender, pages.length - 1);
                const pagesData = documentMapService.updatePagesList(pages, newPages, newPosition);
                documentMapService.updateMap(pageToRender, newPages.length, newPosition);

                setRenderedDoc({
                    pages: pagesData,
                    nextPage: nextPageToRender,
                    totalPages: totalPdfPagesNumber
                });
                setLoadingMorePages(false);
                setLoading(false);
            })
            .catch((error) => {
                setLoadingMorePages(false);
                console.error("Error al cargar las páginas específicas:", error);
                handleSessionExpiredError(error?.response?.status);
            });
    };

    const handleDocumentHeightUpdate = (height, vSelectedPage, vRenderedDoc) => {
        setLoadingMorePages(false);
        setLoading(false);
        documentMapService.setScroll('pdf-container', vSelectedPage, vRenderedDoc.length);
    };

    const appendZero = (value) => {
        return value >= 10 ? value : `0${value}`;
    };

    const formatDate = (date) => {
        let hours = date.getHours();

        const moment = hours >= 12 ? "PM" : "AM";
        hours = hours > 12 ? hours - 12 : hours;

        const formattedDate = [
            appendZero(date.getMonth() + 1),
            appendZero(date.getDate()),
            date.getFullYear()].join('/') + ' ' +
            [appendZero(hours),
            appendZero(date.getMinutes()),
            appendZero(date.getSeconds())].join(':') + ' ' + moment;

        return formattedDate;
    };

    const formatDate2 = (date) => {
        let day = appendZero(date.getDate());
        let month = appendZero(date.getMonth() + 1);
        let year = date.getFullYear();
        let hours = date.getHours();
        let minutes = appendZero(date.getMinutes());
        let seconds = appendZero(date.getSeconds());
        let ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;

        return `${month}/${day}/${year} ${hours}:${minutes}:${seconds} ${ampm}`;
    };

    const parseUTCDate = (dateString) => {
        if (!dateString) return null;
        return new Date(dateString + 'Z');
    };

    const getDocumentInfoAndAttachments = () => {
        let signerGUI = selectedDoc.SignerDTO.SignerGUI;

        getDocumentInfo()
            .then(res => {
                if (res) {
                    var vDocumentInfo = res;
                    var vDocumentSigners = vDocumentInfo.Signers;
                    for (var i = 0; i < vDocumentSigners.length; i++) {
                        const fullUTCUploadTime = vDocumentInfo.UploadTime + ' UTC';
                        const localeUploadTime = new Date(fullUTCUploadTime);
                        vDocumentSigners[i].UploadTime = formatDate(localeUploadTime);
                        if (vDocumentSigners[i].OperationTime) {
                            const localeOperationTime = parseUTCDate(vDocumentSigners[i].OperationTime);
                            vDocumentSigners[i].OperationTime = formatDate2(localeOperationTime);
                        }
                    }
                    getDocumentAttatchmentsList()
                        .then(res => {
                            if (res.length > 0) {
                                var docsAttached = res;
                                var requests = [];
                                for (var i = 0; i < docsAttached.length; i++) {
                                    requests.push(DocumentService.renderAttachment(signerGUI, docsAttached[i].GUID));
                                }
                                var attachedDocsRenderArray = [];
                                Promise.all(requests).then((responses) => {
                                    for (var i = 0; i < responses.length; i++) {
                                        attachedDocsRenderArray.push(responses[i].data.DocPageRendered);
                                    }

                                    var attDocArrayLocal = [];
                                    if (docsAttached.length > 0) {
                                        attDocArrayLocal = docsAttached.map((docAtt, index) => {
                                            return <AttachmentNavItem
                                                key={index}
                                                index={index}
                                                docAtt={docAtt}
                                                signerGuid={signerGUI}
                                                onSelect={() => setDocsAttachedRendered(attachedDocsRenderArray[index])}
                                            />;
                                        });
                                    }
                                    setDocumentInfo(vDocumentInfo);
                                    setDocumentSigners(vDocumentSigners);
                                    setDocumentAttatchmentsList(docsAttached);
                                    setAttDocArray(attDocArrayLocal);
                                    setDocsAttachedRendered(attachedDocsRenderArray[0]);
                                }).catch(errors => {
                                    console.log(errors);
                                });
                            }
                            else {
                                setDocumentInfo(vDocumentInfo);
                                setDocumentSigners(vDocumentSigners);
                                setDocumentAttatchmentsList([]);
                                setAttDocArray([]);
                                setDocsAttachedRendered([]);
                            }
                        })
                        .catch(function (error) { });
                } else {
                    console.log('no user data');
                }
            })
            .catch(function (error) {
                handleSessionExpiredError(error.response.status);
                handlePreviouslyRejectedDocError(error);
                setLoading(false);
            });
    };

    const getDocumentInfo = () => {
        const vPendingDocuments = pendingDocuments;
        var docGUI = selectedDoc.DocGUI;
        if (vPendingDocuments.length === 1) {
            docGUI = vPendingDocuments[0].DocGUI;
        }

        return DocumentService.getDocumentInfo(docGUI)
            .then(res => {
                return res.data;
            })
            .catch(function (error) {
                handleGenericError(error);
                throw error;
            });
    };

    const getDocumentAttatchmentsList = () => {
        var SignerGUI = selectedDoc.SignerDTO.SignerGUI;

        return DocumentService.getDocumentAttatchments(SignerGUI)
            .then(res => {
                return res.data;
            })
            .catch(function (error) {
                if (error.response && error.response.status === 403) {
                    return [];
                }
                handleGenericError(error);
                throw error;
            });
    };

    const renderRefreshDocumentsButton = () => {
        return (
            <RefreshIcon className="refresh-button" onClick={() => getPendingDocuments()} />
        );
    };

    const closeFilterCertificateMsg = () => {
        setDocCertSelected(null);
        setDocsSelectedSignerGUI([]);
        setDocsSelected([]);
        sessionStorage.removeItem('docsSelectedSignerGUIString');
        sessionStorage.removeItem('selectedCertificate');
    };

    const onPageChange = (page, sizePerPage) => {
        const newPaginationMeta = {
            ...paginationMeta,
            PageNumber: page
        };

        dispatch({
            type: DocumentsActionTypes.MODIFY_PAGINATION,
            payload: newPaginationMeta,
        });

        return {

        };
    };

    const onSizePerPageChange = (sizePerPage) => {
        const newPaginationMeta = {
            ...paginationMeta,
            PageSize: sizePerPage,
            PageNumber: 1
        };
        dispatch({
            type: DocumentsActionTypes.MODIFY_PAGINATION,
            payload: newPaginationMeta,
        });
    };

    const shouldHideTagColumn = () => {
        let hiddenColumnTag = true;
        pendingDocuments.forEach((doc) => {
            if (doc.Tag !== "") {
                hiddenColumnTag = false;
                return;
            }
        });

        return hiddenColumnTag;
    };

    const shouldHideSenderNameColumn = () => {
        let hiddenSenderName = true;
        pendingDocuments.forEach((doc) => {
            if (doc.SenderName !== "") {
                hiddenSenderName = false;
                return;
            }
        });

        return hiddenSenderName;
    };

    const getCertificateAlias = () => {
        if (docCertSelected) {
            const docWithCertificate = pendingDocuments.find((doc) => doc.SignerDTO?.CentralizedCertificateInfo?.Guid === docCertSelected);
            const certificate = docWithCertificate?.SignerDTO?.CentralizedCertificateInfo;

            return certificate?.Alias;
        }
    };

    const handleBatchSignature = (validateMultiSignatureDisclaimer = true, validateCertDisclaimer = true) => {
        // Hide advanced search bar to prevent autofill bug from Chrome
        setShowAdvancedSearch(false);

        const containsDisclaimer = docsSelected.some((doc) => doc.SignerDTO.DisclaimerInfo.Display);
        if (containsDisclaimer && validateMultiSignatureDisclaimer) {
            getDisclaimerMessage();
            return;
        }
        setShowAdditionalSignaturesBatchDisclaimer(false);

        if (docCertSelected && validateCertDisclaimer) {
            setShowCommonCertificateDisclaimer(true);
            return;
        }
        setShowCommonCertificateDisclaimer(false);
        filterCertsByDocCert();
    };

    const handleSorting = (field, order) => {
        const newOrdering = {
            OrderType: order === "desc" ? "des" : "asc",
            OrderBy: field.includes("Certificate") ? "CentralizedCertificateAlias" : field,
        };

        dispatch({
            type: DocumentsActionTypes.MODIFY_SORTING,
            payload: newOrdering,
        });
    };

    const getDisclaimerMessage = () => {
        const type = 'SIGNATURE_MULTIPOSITION_BATCH';
        var docSelected;
        docsSelected.some((doc) => doc.SignerDTO.DisclaimerInfo.Display ? docSelected = doc : '');
        const iso2Language = language.slice(0, 2);

        return DocumentService.getDisclaimerMessage(docSelected.SignerDTO.SignerGUI, type, iso2Language)
            .then(res => {
                const disclaimerData = res.data;
                setShowAdditionalSignaturesBatchDisclaimer(true);
                setTextAdditionalSignaturesDisclaimer(disclaimerData.Text);
                setTitleAdditionalSignaturesDisclaimer(disclaimerData.Title);
                return res.data;
            })
            .catch(function (error) {
                if (error.response && error.response.status === 401) {
                    /**SESIÓN CADUCADA REDIRECCIONAR AL LOGIN CON UN ALERT*/
                    setSessionExpired(true);
                    startTimer();
                }
                throw error;
            });
    };

    // ─── Effects ──────────────────────────────────────────────────────────────

    useEffect(() => {
        Utils.appendScript("/assets/js/autoscript.js");
        Utils.appendScript("/assets/js/forge.min.js");
        getClientData();

        ThemeService.setTheme();

        var authCerts = sessionStorage.getItem('authCerts');
        if (authCerts !== null) {
            setUserIsLoggedByAuthCerts(true);
        }
        setOauthTokenB64(sessionStorage.getItem('oauthTokenB64'));

        getPendingDocuments();
        loadViDMobileUserCertificateList();
        documentMapService.resetMap();

        return () => clearInterval(timerRef.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            prevFiltersRef.current = filters;
            prevPaginationMetaRef.current = paginationMeta;
            prevOrderingRef.current = ordering;
            return;
        }

        const oldFilters = prevFiltersRef.current;
        const oldPagination = prevPaginationMetaRef.current;
        const oldOrdering = prevOrderingRef.current;

        prevFiltersRef.current = filters;
        prevPaginationMetaRef.current = paginationMeta;
        prevOrderingRef.current = ordering;

        if (
            oldPagination.PageNumber !== paginationMeta.PageNumber ||
            oldPagination.PageSize !== paginationMeta.PageSize ||
            JSON.stringify(oldOrdering) !== JSON.stringify(ordering) ||
            JSON.stringify(oldFilters) !== JSON.stringify(filters)
        ) {
            getPendingDocuments();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters, paginationMeta, ordering]);

    useEffect(() => {
        if (pendingSignCall !== null) {
            signDocSelection(pendingSignCall);
            setPendingSignCall(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingSignCall]);

    useEffect(() => {
        if (renderDocTrigger > 0) {
            renderDocument();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [renderDocTrigger]);

    // ─── Render ───────────────────────────────────────────────────────────────

    const { pages, totalPages } = renderedDoc;

    const parentState = {
        oauthTokenB64, language, userToken, urlReturn, docsSelectedSignerGUI,
        viewDocument, loading, sessionExpired, redirect, time, selectedDoc, renderedDoc,
        rejectedDoc, signedDoc, redirecting, tokenExpired, docsSelected, docCertSelected,
        certificatesList, showSignModal, showKeyVaultModal, showFirmaRemotaModal,
        showRedTrustModal, showSoftwareModal, showUanatacaModalPin, showUanatacaModalOtp,
        showValidatedIdModalPin, showValidatedIdModalOtp, showNebulaModal, showSwisscomModal,
        showAutofirmaModal, showSwisscomConfirmationModal, showNoPinConfirmationModal,
        certificateSoftwarePin, certificateKeyVaultPin, certificateFirmaRemotaPin,
        certificateRedTrustPin, certificateUanatacaPin, certificateUanatacaOtp,
        certificateValidatedIdPin, certificateValidatedIdOtp, certificateNebulaPin,
        certificateSelected, loadingSignatureProcess, sessionOpened, showError, errorData,
        errorType, docsSigned, certHidden, userIsLoggedByAuthCerts, showJumbotron, documentInfo,
        documentSigners, documentAttatchmentsList, docsAttachedRendered, swisscomRedirectURL,
        swisscomRequestID, loadingSwisscomCheck, swisscomError, loadingSwisscomRequest,
        autofirmaPercentage, clientIp, ipData,
        loadingMorePages, previouslyRejectedDoc, showAdvancedSearch, nebulaStep1, nebulaStep2,
        nebulaStep3, showAdditionalSignaturesBatchDisclaimer, showWarningModal, selectedCertificate,
        loadingNebula, currentDataAutofirma, showChallengeError, nebulaPinRequired,
        isUanatacaQualified, isValidatedIdQualified, preventBatchModal, nextDocument,
        accessMethod, forceDocumentView, showIvnosysModal, userData,
        userCertificatesAuth, userCertsFiltered, NBauthenticator, NBChallenge,
        textAdditionalSignaturesDisclaimer, titleAdditionalSignaturesDisclaimer,
        loadingSignatureProcessAutofirma, attDocArray, pageToScroll
    };

    if (redirect) {
        return <Redirect to={{
            pathname: '/'
        }}
        />;
    }

    if (userIsLoggedByAuthCerts) {
        return <Redirect to={{
            pathname: '/authcerts'
        }}
        />;
    }

    const allDocsNonSelectable = pendingDocuments.every(doc => doc.SignerDTO.ReadAll || isCertConflict(doc));

    /**selectRow: opciones de la columna de checkbox*/
    const selectRow = {
        mode: 'checkbox',
        hideSelectAll: isSelectAllHidden(),
        clickToSelect: true,
        selectColumnStyle: { verticalAlign: "middle" },
        onSelect: handleOnSelect,
        onSelectAll: handleOnSelectAll,
        selected: docsSelectedSignerGUI,
        nonSelectable: pendingDocuments
            .filter(doc => doc.SignerDTO.ReadAll || isCertConflict(doc))
            .map(doc => doc.SignerDTO.SignerGUI),
        selectionRenderer: ({ checked, disabled, mode, rowKey }) => {
            if (allDocsNonSelectable) return null;

            if (disabled) {
                const disabledDoc = pendingDocuments.find(doc => doc.SignerDTO.SignerGUI === rowKey);
                const tooltipKey = disabledDoc && disabledDoc.SignerDTO.ReadAll
                    ? 'documents.tooltip-read-all'
                    : (docCertSelected ? 'documents.tooltip-different-certificate' : 'documents.tooltip-multiple-certificates');

                return <div className="lock-container">
                    <img src={lockIcon} alt="Lock Icon" className='icon' />
                    <div className="lock-container-popup">
                        {t(tooltipKey)}
                    </div>
                </div>;
            }

            return (
                <input
                    checked={checked}
                    type={mode}
                    readOnly
                    style={{ pointerEvents: 'none' }}
                />
            );
        }
    };

    const columns = [
        {
            dataField: 'FileName',
            text: t('documents.document'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'documents-headerClass1',
            style: { verticalAlign: 'middle' },
            onSort: handleSorting,
            formatter: (cellContent, row) => {
                const attachment = row?.SignerDTO?.HasAttachment;
                const additionalInfo = row?.Description;

                return (
                    <div className="filename-container">
                        <label>{cellContent}</label>
                        <div className='filename-label-popup'>{cellContent}</div>
                        {attachment && (
                            <img src={attachmentIcon} alt="Attachment Icon" />
                        )}
                        {additionalInfo && (
                            <div className="hdg-label-info">
                                <img src={infoIcon} alt="Additional Info Icon" className='icon' />
                                <div className="hdg-label-popup">
                                    {additionalInfo}
                                </div>
                            </div>
                        )}
                    </div>
                );
            }
        },
        {
            dataField: 'UploadTime',
            text: t('documents.sent'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'documents-headerClass2',
            style: { verticalAlign: 'middle' },
            onSort: handleSorting,
            formatter: (cellContent, row) => {
                const datetime = row?.UploadTime;
                if (!datetime) return '';
                const date = datetime.split(" ")[0];

                return date;
            }
        },
        {
            dataField: 'Tag',
            text: t('documents.tag'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'documents-headerClass2',
            style: { verticalAlign: 'middle' },
            onSort: handleSorting,
            hidden: shouldHideTagColumn(),
            formatter: (cellContent, row) => <TagsList tagString={row?.Tag} />
        },
        {
            dataField: 'SenderName',
            text: t('documents.sender'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'documents-headerClass2',
            style: { verticalAlign: 'middle' },
            onSort: handleSorting,
            hidden: shouldHideSenderNameColumn(),
            formatter: (_, row) => row?.SenderName ? row.SenderName : t('documents.document-cert-undef'),
        },
        {
            dataField: 'SignerDTO.CentralizedCertificateInfo.Guid',
            text: t('documents.cert-type'),
            align: 'left',
            sort: true,
            headerAlign: 'left',
            headerClasses: 'documents-headerClass2',
            onSort: handleSorting,
            style: { verticalAlign: 'middle' },
            hidden: certHidden,
            formatter: (cellContent, row) => {
                if (row?.SignerDTO.CentralizedCertificateInfo) {
                    if (row.SignerDTO.CentralizedCertificateInfo.Alias !== null) {
                        return row.SignerDTO.CentralizedCertificateInfo.Alias;
                    }
                }
                return t('documents.document-cert-undef');
            }
        },
        {
            dataField: 'ActionButton',
            text: "",
            align: 'center',
            headerAlign: 'left',
            onSort: handleSorting,
            isDummyField: true,
            style: { verticalAlign: 'middle' },
            headerClasses: 'documents-headerClass3',
            formatter: (cellContent, row, rowIndex) => {
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <IconButton
                            tooltipText={t('documents.see')}
                            onClick={(e) => seeDocument(e, row)}
                            icon={EyeIcon}
                        />
                    </div>
                );
            }
        }
    ];

    const paginationOptions = {
        custom: true,
        showTotal: true,
        totalSize: paginationMeta.Count,
        sizePerPage: paginationMeta.PageSize,
        page: paginationMeta.PageNumber,
        paginationSize: 3,
        firstPageText: t('general.first'),
        prePageText: t('general.pre'),
        nextPageText: t('general.next'),
        lastPageText: t('general.last'),
        nextPageTitle: t('general.first-page'),
        prePageTitle: t('general.pre-page'),
        firstPageTitle: t('general.next-page'),
        lastPageTitle: t('general.last-page'),
        sizePerPageList: [{
            text: '5', value: 5
        }, {
            text: '10', value: 10
        }, {
            text: '30', value: 30
        }, {
            text: '50', value: 50
        }, {
            text: '100', value: 100
        }],
        onPageChange: onPageChange,
        onSizePerPageChange: onSizePerPageChange
    };

    const contentTable = ({ paginationProps, paginationTableProps }) => (
        <div>
            <ToolkitProvider
                keyField='SignerDTO.SignerGUI'
                data={pendingDocuments}
                columns={columns}
                search={false}
                bootstrap4
            >
                {
                    toolkitprops => (
                        <div>
                            {docCertSelected && !showAdvancedSearch &&
                                <div className="filter-list-container">
                                    <FilterCertificateMsg filter={t('documents.cert-type') + ": " + getCertificateAlias()} close={() => closeFilterCertificateMsg()} />
                                </div>
                            }
                            <BootstrapTable
                                striped
                                hover
                                condensed
                                onTableChange={() => { }}
                                remote={{ sorting: true, pagination: true }}
                                sort={{
                                    dataField: ordering.OrderBy,
                                    order: ordering.OrderType === "des" ? "desc" : "asc"
                                }}
                                bordered={false}
                                selectRow={selectRow}
                                {...toolkitprops.baseProps}
                                {...paginationTableProps}
                            />
                        </div>
                    )
                }
            </ToolkitProvider>
            <div className="table-pagination-container">
                <SizePerPageDropdownStandalone
                    {...paginationProps}
                    className={'page-dropdown'}
                />
                <PaginationListStandalone
                    {...paginationProps}
                />
            </div>
        </div>
    );

    var timeText = language === 'es' ? 'Hace ' + time + ' minutos' : language === 'en' ? time + ' minutes ago' : language === 'ca' ? 'Fa ' + time + ' minuts' : 'Hace ' + time + ' minutos';

    return (
        <div className="documents-container">
            {rejectedDoc && (
                <ToastComponent
                    onClose={() => setRejectedDoc(false)}
                    show={rejectedDoc}
                    autohide
                    delay={3000}
                    title={t('general.rejected')}
                    message={t('general.rejected-text')}
                    variant="error"
                    zIndex={10}
                />
            )}
            {signedDoc &&
                <ToastComponent
                    onClose={() => setSignedDoc(false)}
                    show={signedDoc}
                    autohide
                    delay={3000}
                    title={t('general.signed')}
                    message={t('general.signed-text')}
                    variant="success"
                    zIndex={10}
                />
            }
            {redirecting &&
                <ToastComponent
                    onClose={() => setRedirecting(false)}
                    show={redirecting}
                    autohide
                    delay={3000}
                    title={t('general.exit')}
                    message={t('general.exit-text')}
                    variant="info"
                    zIndex={10}
                />
            }
            {tokenExpired &&
                <ToastComponent
                    onClose={() => setTokenExpired(false)}
                    show={tokenExpired}
                    autohide
                    delay={3000}
                    title={t('general.exit')}
                    message={t('general.exit-text2')}
                    variant="warning"
                    zIndex={10}
                />
            }
            {showError &&
                <ToastComponent
                    onClose={() => setShowError(false)}
                    show={showError}
                    title={<>{t('general.error')} {errorType}</>}
                    message={errorData}
                    variant="error"
                    closeButton
                    zIndex={15}
                />
            }
            {previouslyRejectedDoc &&
                <ToastComponent
                    onClose={() => {
                        getPendingDocuments();
                        setPreviouslyRejectedDoc(false);
                        setViewDocument(false);
                    }}
                    show={previouslyRejectedDoc}
                    title={t('general.error')}
                    message={t('general.rejected')}
                    variant="error"
                    closeButton
                />
            }
            {sessionExpired &&
                <ToastComponent
                    show={sessionExpired}
                    title={t('general.notification')}
                    subtitle={timeText}
                    variant="session-expired"
                    zIndex={10}
                    closeButton={false}
                >
                    <p>{t('general.session-expired')}</p>
                    <Button
                        type="button"
                        className="btn btn-primary"
                        id="sign-all-docs"
                        onClick={() => doLogOut()}
                    >
                        {t('general.accept')}
                    </Button>
                </ToastComponent>
            }
            <Header />
            <TrustProSyncBanner show={showTrustProSyncBanner} />
            {(!viewDocument && showJumbotron) &&
                <Jumbotron>
                    <MdClose className="close-jumbotron" onClick={() => setShowJumbotron(!showJumbotron)} />
                    <div className="jumbotron-content">
                        <img src={warning} alt="Warning icon" />
                        <p>
                            {t('documents.pending')}. {t('documents.pending-text')}
                        </p>
                    </div>
                </Jumbotron>
            }
            {
                loadingMorePages &&
                <div className="loading-more-container">
                    <LoadingCircle />
                </div>
            }
            {(!loading && !viewDocument && pendingDocuments.length > 0) &&
                <div className="documents-table-container">
                    <CustomModal
                        text={textAdditionalSignaturesDisclaimer}
                        title={titleAdditionalSignaturesDisclaimer}
                        show={showAdditionalSignaturesBatchDisclaimer}
                        handleHide={() => setShowAdditionalSignaturesBatchDisclaimer(false)}
                        handleConfirm={() => handleBatchSignature(false, true)}
                    />
                    <CustomModal
                        show={showCommonCertificateDisclaimer}
                        handleHide={() => setShowCommonCertificateDisclaimer(false)}
                        handleConfirm={() => handleBatchSignature(false, false)}
                        title={t('documents.common-certificate-disclaimer-title')}
                    >
                        {getCertificateAlias()} {t('documents.common-certificate-disclaimer-text')}
                    </CustomModal>
                    <CustomModal
                        show={showIncompatibleCertificatesModal}
                        handleHide={() => setShowIncompatibleCertificatesModal(false)}
                        handleConfirm={() => setShowIncompatibleCertificatesModal(false)}
                        title={t('documents.warning')}
                        singleButton={true}
                    >
                        {t('documents.incompatible-certificates-error')}
                    </CustomModal>
                    <CustomModal
                        show={showSignModal}
                        handleHide={() => handleClose()}
                        title={t('documents.cert-type-selection')}
                        singleButton={true}
                    >
                        <ListGroup defaultActiveKey="#link1">
                            {certificatesList}
                        </ListGroup>
                    </CustomModal>

                    <KeyVaultSignature
                        show={showKeyVaultModal}
                        onClose={handleClose}
                        onSuccess={handleModalSignatureSuccess}
                        certificateSelected={certificateSelected} />

                    <FirmaRemota
                        show={showFirmaRemotaModal}
                        onClose={handleClose}
                        onSuccess={handleModalSignatureSuccess}
                        certificateSelected={certificateSelected} />

                    <RedTrustSignature
                        show={showRedTrustModal}
                        onClose={handleClose}
                        onSuccess={handleModalSignatureSuccess} />

                    <UanatacaSignature
                        showModalPin={showUanatacaModalPin}
                        showModalOtp={showUanatacaModalOtp}
                        onClose={handleClose}
                        onSuccessOtp={handleModalSignatureOtpSuccess}
                        onSuccess={handleModalSignatureSuccess} />

                    <ValidatedIdSignature
                        showModalPin={showValidatedIdModalPin}
                        showModalOtp={showValidatedIdModalOtp}
                        onClose={handleClose}
                        onSuccessOtp={handleModalSignatureValidatedIdSuccess}
                        onSuccess={handleModalSignatureSuccess} />

                    <SoftwareSignature
                        show={showSoftwareModal}
                        onClose={handleClose}
                        onSuccess={handleModalSignatureSuccess} />

                    <SwisscomSignature
                        parentState={parentState}
                        onClose={handleClose}
                        onSuccessSignDocSelection={() => {
                            setShowSwisscomModal(false);
                            setShowSwisscomConfirmationModal(true);
                            setLoadingSwisscomRequest(true);
                            setPendingSignCall(SWISSCOM);
                        }}
                        onSuccess={() => {
                            setLoadingSwisscomCheck(true);
                            setSwisscomError('');
                            completeSwisscomSignature();
                        }} />

                    <AutofirmaSignature show={showAutofirmaModal}
                        onClose={handleClose}
                        loadingSignatureProcessAutofirma={loadingSignatureProcessAutofirma}
                        currentDataAutofirma={currentDataAutofirma}
                        docsSelected={docsSelected}
                        autofirmaPercentage={autofirmaPercentage} />

                    <IvnosysSignature
                        signerGuid={docsSelected.length > 0 ? docsSelected[0].SignerDTO.SignerGUI : ''}
                        showModalPin={showIvnosysModal}
                        onClose={handleClose}
                        certificateSelected={certificateSelected}
                        onSuccess={handleModalSignatureSuccess}
                    />

                    <NebulaSignature
                        onChangeFormControl={(e) => handleAuthenticatorChange(e)}
                        onSendAuthenticator={sendAuthenticator}
                        parentState={parentState}
                        authenticators={authenticatorsRef.current}
                        onClose={handleClose}
                        onChallengeChange={e => setNBChallenge(e.target.value)}
                        onSendChallenge={sendChallenge}
                        onFocusInput={(input) => { focusInput(input); }}
                        onCertificatePinChange={e => setCertificateNebulaPin(e.target.value)}
                        onSignDoc={() => {
                            setLoadingSignatureProcess(true);
                            setShowNebulaModal(false);
                            setPendingSignCall(NEBULA);
                        }}
                    />

                    <CustomModal
                        show={showNoPinConfirmationModal}
                        handleHide={() => handleClose()}
                        handleConfirm={() => handleNoPinDocSignature()}
                        title={t('documents.no-pin-title')}
                        text={t('documents.no-pin-text')}
                    />

                    <CustomModal
                        show={showWarningModal}
                        handleHide={() => handleClose()}
                        handleConfirm={() => { setShowWarningModal(false); handleClose(); }}
                        title={t('documents.warning')}
                    >
                        {selectedCertificate} {t('documents.certificate-unavailable')}
                    </CustomModal>

                    <CustomModal
                        show={preventBatchModal}
                        handleHide={() => setPreventBatchModal(false)}
                        handleConfirm={() => setPreventBatchModal(false)}
                        title={t('documents.warning')}
                        singleButton={true}
                    >
                        {selectedCertificate === "KeyVault" ? `KeyVault (Verified Credentials)` : selectedCertificate} {t('documents.certificate-unavailable')}
                    </CustomModal>

                    <SigningProcessModal
                        showModal={loadingSignatureProcess}
                        showProcess={true}
                        signedDocs={docsSigned}
                        selectedDocs={docsSelected.length} />

                    <SearchBar
                        updateState={(newState) => Object.entries(newState).forEach(([k, v]) => setStateByKey(k, v))}
                        selectedCert={docCertSelected}
                        showTag={!shouldHideTagColumn()}
                        showSenderNameColumn={!shouldHideSenderNameColumn()}
                        showCertificate={!certHidden}
                        docsSelectedSignerGUI={docsSelectedSignerGUI}
                        showAdvancedSearch={showAdvancedSearch}
                        setShowAdvancedSearch={(val) => setShowAdvancedSearch(val)}
                    >
                        {renderRefreshDocumentsButton()}
                    </SearchBar>

                    <PaginationProvider
                        pagination={paginationFactory(paginationOptions)}>
                        {contentTable}
                    </PaginationProvider>
                    <div className='button-container'>
                        <Button
                            type="button"
                            disabled={docsSelectedSignerGUI.length === 0 || null}
                            className={docsSelectedSignerGUI.length === 0 || null ? "btn btn-primary button-disabled" : "btn btn-primary"}
                            id="sign-all-docs"
                            onClick={() => handleBatchSignature(true)}
                        >
                            {t('documents.sign-selected')}
                        </Button>
                    </div>
                </div>
            }
            {(!loading && !viewDocument && pendingDocuments.length === 0) &&
                <EmptyDocsPanel onClickGetPendingDocuments={() => getPendingDocuments()} />
            }
            {loading &&
                <LoadingCircle centerVertically={true} />
            }
            {(viewDocument && pages.length > 0) &&
                <DocumentPreview
                    renderedDoc={pages}
                    selectedDoc={selectedDoc}
                    pendingSignatures={pendingDocuments}
                    documentInfo={documentInfo}
                    documentSigners={documentSigners}
                    documentAttatchmentsList={documentAttatchmentsList}
                    attDocArray={attDocArray}
                    docsAttachedRendered={docsAttachedRendered}
                    viewDocumentHandler={viewDocumentHandler}
                    showRejectedDocHandler={showRejectedDocHandler}
                    showSignedDocHandler={showSignedDocHandler}
                    totalPages={totalPages}
                    renderDocument={renderDocument}
                    handlePreviouslyRejectedDocError={handlePreviouslyRejectedDocError}
                    seeNextDocument={seeNextDocument}
                    checkedDocs={docsSelectedSignerGUI}
                    updateSelectedDocs={handleOnSelect}
                    isDocSelectionLocked={(doc) => doc.SignerDTO.ReadAll || isCertConflict(doc)}
                    getSelectionLockTooltipKey={(doc) => doc.SignerDTO.ReadAll
                        ? 'documents.tooltip-read-all'
                        : (docCertSelected ? 'documents.tooltip-different-certificate' : 'documents.tooltip-multiple-certificates')}
                    forceDocumentView={forceDocumentView}
                    renderSpecificPage={renderSpecificPage}
                    pageToScroll={pageToScroll}
                    onDocumentHeightUpdate={handleDocumentHeightUpdate}
                    loadingMorePages={loadingMorePages}
                />
            }
        </div>
    );
};

export default withTranslation()(Documents);
